import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Base64: any;
  DateTime: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Album = {
  id: Scalars['ID'];
  sandboxes: Array<Sandbox>;
  title?: Maybe<Scalars['String']>;
};

export enum AuthType {
  Basic = 'BASIC',
  Bearer = 'BEARER'
}

export enum Authorization {
  Comment = 'COMMENT',
  None = 'NONE',
  Owner = 'OWNER',
  Read = 'READ',
  WriteCode = 'WRITE_CODE',
  WriteProject = 'WRITE_PROJECT'
}

export type BillingDetails = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  date: Scalars['String'];
};

/** DEPRECATED: Conversion to usage-based billing uses InvoicePreview instead */
export type BillingPreview = {
  immediatePayment?: Maybe<BillingDetails>;
  nextPayment?: Maybe<BillingDetails>;
};

/** A team or the current user */
export type BookmarkEntity = Team | User;

export type Bookmarked = {
  entity?: Maybe<BookmarkEntity>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
};

/**
 * Branch of a Repository imported to CodeSandbox.
 *
 * Branches often represent git branches available from the git provider, but they can also
 * represent the contributions of read-only users that have not yet forked and committed their work.
 * Branches on CodeSandbox do not persist to the git provider until a commit is made, and branches
 * on the git provider don't appear in CodeSandbox unless imported by an automated process (like the
 * GitHub App webhooks) or manually by a user.
 */
export type Branch = {
  /**
   * Whether or not AI features should be enabled for this branch.
   *     This is the final calculated value based on the team subscription status, team settings, and project settings.
   */
  aiConsent: Scalars['Boolean'];
  /** Active users connected to this branch */
  connections: Array<Connection>;
  /** Whether this branch is a contribution branch made by a read-only user */
  contribution: Scalars['Boolean'];
  /**
   * Whether the current user is the owner of this contribution branch. Can be
   *     used to override project-level `READ` authorization. Always returns `false` if the
   *     current branch is not a contribution branch.
   */
  contributionOwner: Scalars['Boolean'];
  /** Alphanumeric short ID of the branch, for use with Pitcher */
  id: Scalars['String'];
  /** Timestamp of the last time the current user accessed this branch on CodeSandbox */
  lastAccessedAt?: Maybe<Scalars['String']>;
  /** Information about the last commit made by CodeSandbox on this branch */
  lastCommit?: Maybe<LastCommit>;
  /** Branch name as it appears in git */
  name: Scalars['String'];
  /** Branch owner, in the case of a contribution branch by a read-only user */
  owner?: Maybe<User>;
  /** Parent project of this branch */
  project: Project;
  /** Open pull requests from this head branch */
  pullRequests: Array<PullRequest>;
  settings: BranchSettings;
  /** The name of the branch the current branch was created from. Only available if this branch was created via CodeSandbox. */
  sourceBranch?: Maybe<Scalars['String']>;
  /** Information about the underlying git status of this branch */
  status?: Maybe<Status>;
  /** Whether or not this branch exists on GitHub. Deduced from local information, so not guaranteed 100% accurate */
  upstream: Scalars['Boolean'];
};

/** Subscription update about active users connected to a branch */
export type BranchConnections = {
  branchId: Scalars['String'];
  connections: Array<Connection>;
};

/** Events related to a specific branch. */
export type BranchEvent = PullRequestCommentEvent | PullRequestEvent | PullRequestReviewCommentEvent | PullRequestReviewEvent;

/** Subscription update about a commit made by CodeSandbox for a branch */
export type BranchLastCommit = {
  branchId: Scalars['String'];
  lastCommit: LastCommit;
};

/** Settings for this branch. Stored with the branch so does not incur an extra db query */
export type BranchSettings = {
  protected: Scalars['Boolean'];
};

/** Subscription update about the underlying git status of a branch */
export type BranchStatus = {
  branchId: Scalars['String'];
  status: Status;
};

export type CodeReference = {
  anchor: Scalars['Int'];
  code: Scalars['String'];
  head: Scalars['Int'];
  lastUpdatedAt: Scalars['String'];
  path: Scalars['String'];
};

export type CodeReferenceMetadata = {
  anchor: Scalars['Int'];
  code: Scalars['String'];
  head: Scalars['Int'];
  path: Scalars['String'];
  sandboxId: Scalars['String'];
};

/** A collaborator on a sandbox */
export type Collaborator = {
  authorization: Authorization;
  id: Scalars['UUID4'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  sandbox: Sandbox;
  user: User;
  warning?: Maybe<Scalars['String']>;
};

export type Collection = {
  id?: Maybe<Scalars['UUID4']>;
  path: Scalars['String'];
  sandboxCount: Scalars['Int'];
  sandboxes: Array<Sandbox>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['UUID4']>;
  user?: Maybe<User>;
};

/** A comment on a sandbox. A comment can also have replies and references. */
export type Comment = {
  anchorReference?: Maybe<Reference>;
  comments: Array<Comment>;
  content?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['NaiveDateTime'];
  isRead: Scalars['Boolean'];
  isResolved: Scalars['Boolean'];
  parentComment?: Maybe<Comment>;
  references: Array<Reference>;
  replyCount: Scalars['Int'];
  sandbox: Sandbox;
  updatedAt: Scalars['NaiveDateTime'];
  user: User;
};

/** Information about an active user connection to a project branch */
export type Connection = {
  appId: Scalars['String'];
  clientId: Scalars['String'];
  color: Scalars['String'];
  timestamp: Scalars['String'];
  user?: Maybe<User>;
};

export type CurrentUser = {
  bookmarkedTemplates: Array<Template>;
  collaboratorSandboxes: Array<Sandbox>;
  collection?: Maybe<Collection>;
  collections: Array<Collection>;
  deletionRequested: Scalars['Boolean'];
  /**
   * Whether this user should be offered a trial
   *
   * Returns false if they have created any teams that have used a trial in the last 6 months.
   */
  eligibleForTrial: Scalars['Boolean'];
  /**
   * List workspaces a user is eligible to join
   *
   * This endpoint looks at the user's verified email address domains to find workspaces that allow
   * automatically joining.
   *
   * Note that this endpoint is _expensive_ to calculate, and should only be called when necessary.
   */
  eligibleWorkspaces: Array<TeamPreview>;
  email: Scalars['String'];
  /** User-based feature flags and whether or not they are active for the current user */
  featureFlags: UserFeatureFlags;
  /** Get all of the current user's GitHub organizations */
  githubOrganizations?: Maybe<Array<GithubOrganization>>;
  /** GitHub profile information for the current user */
  githubProfile?: Maybe<GithubProfile>;
  /**
   * Get GitHub repositories owned by the current user.
   *
   * If either `page` or `perPage` are specified, then a single page of results will be returned.
   * If neither argument is given, then all results will be returned. Note that this still requires
   * paginated requests to the GitHub API, but the server will concatenate the results.
   *
   * Defaults to sorting by repository name (`sort` value `FULL_NAME`). In this case, repositories
   * are returned in ascending order. If any other value is given, repositories are returned in
   * descending order (ex. most recently pushed first).
   */
  githubRepos: Array<GithubRepo>;
  id: Scalars['UUID4'];
  likedSandboxes: Array<Sandbox>;
  name?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferences>;
  notifications: Array<Notification>;
  personalWorkspaceId: Scalars['UUID4'];
  primaryWorkspaceId?: Maybe<Scalars['UUID4']>;
  provider: ProviderName;
  recentBranches: Array<Branch>;
  recentProjects: Array<Project>;
  recentlyAccessedSandboxes: Array<Sandbox>;
  recentlyUsedTemplates: Array<Template>;
  sandboxes: Array<Sandbox>;
  team?: Maybe<Team>;
  teams: Array<Team>;
  templates: Array<Template>;
  username: Scalars['String'];
  workspaces: Array<Team>;
};


export type CurrentUserCollectionArgs = {
  path: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};


export type CurrentUserCollectionsArgs = {
  teamId?: InputMaybe<Scalars['ID']>;
};


export type CurrentUserGithubReposArgs = {
  affiliation?: InputMaybe<Array<UserRepoAffiliation>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UserRepoSort>;
};


export type CurrentUserNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CurrentUserRecentBranchesArgs = {
  contribution?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type CurrentUserRecentProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type CurrentUserRecentlyAccessedSandboxesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type CurrentUserRecentlyUsedTemplatesArgs = {
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type CurrentUserSandboxesArgs = {
  hasOriginalGit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CurrentUserTeamArgs = {
  id?: InputMaybe<Scalars['UUID4']>;
};


export type CurrentUserTemplatesArgs = {
  showAll?: InputMaybe<Scalars['Boolean']>;
  teamId?: InputMaybe<Scalars['UUID4']>;
};

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A v1 git object */
export type Git = {
  baseGitSandboxes: Array<Sandbox>;
  branch?: Maybe<Scalars['String']>;
  commitSha?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  originalGitSandboxes: Array<Sandbox>;
  path?: Maybe<Scalars['String']>;
  repo?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};


/** A v1 git object */
export type GitBaseGitSandboxesArgs = {
  teamId?: InputMaybe<Scalars['UUID4']>;
};


/** A v1 git object */
export type GitOriginalGitSandboxesArgs = {
  teamId?: InputMaybe<Scalars['UUID4']>;
};

/** Relationship between a user and repository */
export enum GitHubAuthorAssociation {
  Collaborator = 'COLLABORATOR',
  Contributor = 'CONTRIBUTOR',
  FirstTimer = 'FIRST_TIMER',
  FirstTimeContributor = 'FIRST_TIME_CONTRIBUTOR',
  Mannequin = 'MANNEQUIN',
  Member = 'MEMBER',
  None = 'NONE',
  Owner = 'OWNER'
}

/** Comment on a GitHub pull request that is not part of a review */
export type GitHubPullRequestComment = {
  /** Relationship between the comment author and the repository */
  authorAssociation: GitHubAuthorAssociation;
  /** Raw (markdown and/or HTML) body of the comment */
  body: Scalars['String'];
  /** Original creation date of the comment */
  createdAt: Scalars['DateTime'];
  /** Link to view the comment on GitHub */
  htmlUrl: Scalars['String'];
  /** GitHub ID */
  id: Scalars['Int'];
  /** ID of the parent pull request */
  issueId: Scalars['Int'];
  /** Last edit or reaction date of the comment */
  updatedAt: Scalars['DateTime'];
  /** If available, the CodeSandbox user who created the comment */
  user?: Maybe<User>;
  /** GitHub username of the user who created the comment */
  username: Scalars['String'];
};

/** Ways to merge a pull request */
export enum GitHubPullRequestMergeMethod {
  Merge = 'MERGE',
  Rebase = 'REBASE',
  Squash = 'SQUASH'
}

/** The action to take with a pull request review */
export enum GitHubPullRequestReviewAction {
  Approve = 'APPROVE',
  Comment = 'COMMENT',
  RequestChanges = 'REQUEST_CHANGES'
}

/** Comment on a GitHub pull request review */
export type GitHubPullRequestReviewComment = {
  /** Relationship between the comment author and the repository */
  authorAssociation: GitHubAuthorAssociation;
  /** Raw (markdown and/or HTML) body of the comment */
  body: Scalars['String'];
  /** SHA of the commit to which the comment applies */
  commitId: Scalars['String'];
  /** Original creation date of the comment */
  createdAt: Scalars['DateTime'];
  /** Diff of the line that the comment refers to */
  diffHunk: Scalars['String'];
  /** Link to view the comment on GitHub */
  htmlUrl: Scalars['String'];
  /** GitHub ID */
  id: Scalars['Int'];
  /** Parent comment ID (in the context of a thread) */
  inReplyToId?: Maybe<Scalars['Int']>;
  /** Line of the blob to which the comment applies. Last line of the range for a multi-line comment. */
  line?: Maybe<Scalars['Int']>;
  /** SHA of the original commit to which the comment applies */
  originalCommitId: Scalars['String'];
  /** Line of the blob to which the comment applies. Last line of the range for a multi-line comment */
  originalLine?: Maybe<Scalars['Int']>;
  /** First line of the range for a multi-line comment */
  originalStartLine?: Maybe<Scalars['Int']>;
  /** Relative path of the file to which the comment applies */
  path: Scalars['String'];
  /** ID of the parent pull request review */
  pullRequestReviewId?: Maybe<Scalars['Int']>;
  /** Side of the diff to which the comment applies. Side of the last line of the range for a multi-line comment */
  side?: Maybe<GitHubPullRequestReviewCommentSide>;
  /** First line of the range for a multi-line comment */
  startLine?: Maybe<Scalars['Int']>;
  /** Side of the first line of the range for a multi-line comment */
  startSide?: Maybe<GitHubPullRequestReviewCommentSide>;
  /** Level at which the comment is targeted, can be a diff line or a file */
  subjectType?: Maybe<GitHubPullRequestReviewCommentSubjectType>;
  /** Last edit or reaction date of the comment */
  updatedAt: Scalars['DateTime'];
  /** If available, the CodeSandbox user who created the comment */
  user?: Maybe<User>;
  /** GitHub username of the user who created the comment */
  username: Scalars['String'];
};

/** Which side of a side-by-side diff a PR review comment pertains to */
export enum GitHubPullRequestReviewCommentSide {
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Whether a review comment pertains to an entire file or specific line(s) */
export enum GitHubPullRequestReviewCommentSubjectType {
  File = 'FILE',
  Line = 'LINE'
}

/**
 * Repository as it appears on GitHub
 *
 * Repositories may be imported to CodeSandbox multiple times (for multiple teams). When possible,
 * data in this object will match what is currently available on GitHub. Note that some data may
 * be out of date.
 *
 * Over time, multiple distinct repositories (with different IDs) may have the same owner and name.
 * CodeSandbox will always communicate information about the most recent repository it knows about.
 */
export type GitHubRepository = {
  /** Whether the repository can be forked; may be disabled in the GitHub repository settings */
  allowForking: Scalars['Boolean'];
  /** Whether the repository is archived (and therefore read-only) */
  archived: Scalars['Boolean'];
  /** Original creation date of the repository */
  createdAt: Scalars['DateTime'];
  /** Default branch, for example `main` */
  defaultBranch: Scalars['String'];
  /** Optional description of the repository */
  description?: Maybe<Scalars['String']>;
  /** Whether the repository is a fork of another repository */
  fork: Scalars['Boolean'];
  /** Integer ID assigned by GitHub */
  id: Scalars['Int'];
  /** Whether the repository is configured as a template repository */
  isTemplate: Scalars['Boolean'];
  /** Name of the repository, not including the owner */
  name: Scalars['String'];
  /** Login name of the owning user or organization */
  owner: Scalars['String'];
  /** Direct ascendant repository, if this repository is a fork */
  parent?: Maybe<GitHubRepository>;
  /** Current user's permission to the repository; `none` if unavailable */
  permission: GithubPermission;
  /** Whether the repository is private to a user or organization */
  private: Scalars['Boolean'];
  /** Time of the most recent push to any branch on the repository */
  pushedAt: Scalars['DateTime'];
  /** Original ascendant repository, if this repository is a fork; may be the same as the parent */
  source?: Maybe<GitHubRepository>;
  /** Time of the most recent change to the repository's metadata */
  updatedAt: Scalars['DateTime'];
};

export enum GitProvider {
  Github = 'GITHUB'
}

/**
 * Organization as it appears on GitHub (intersection of Open API `simple-user` and
 * `organization-simple`)
 */
export type GithubOrganization = {
  /** URL for organization image */
  avatarUrl: Scalars['String'];
  /** Optional organization description */
  description?: Maybe<Scalars['String']>;
  /** Integer ID */
  id: Scalars['ID'];
  /** Organization name */
  login: Scalars['String'];
};

/** Current user's permission to the parent resource */
export enum GithubPermission {
  Admin = 'ADMIN',
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE'
}

/**
 * User profile for an authenticated user.
 *
 * This field can be used to determine if a user has explicitly connected their GH account, since it
 * will be null unless we have a GitHub token. Just having created an account with GitHub is not
 * enough to populate this field.
 */
export type GithubProfile = {
  /** URL for user profile image */
  avatarUrl: Scalars['String'];
  /** Integer ID */
  id: Scalars['ID'];
  /** GitHub username */
  login: Scalars['String'];
  /** Real name */
  name?: Maybe<Scalars['String']>;
  /** List of OAuth scopes the user has granted */
  scopes: Array<Scalars['String']>;
};

export type GithubPullRequestReviewCommentInput = {
  /** Body text of the review comment */
  body: Scalars['String'];
  /** Line number of the file to comment on. Note: This line must be part of the diff */
  line: Scalars['Int'];
  /** Relative path to the file being commented on */
  path: Scalars['String'];
  /** Which side of the diff to comment on. */
  side: GitHubPullRequestReviewCommentSide;
  /** Start line of multi-line comment. Only needed for multi-line comments. */
  startLine?: InputMaybe<Scalars['Int']>;
  /** Start side of multi-line comment. Only needed for multi-line comments. */
  startSide?: InputMaybe<GitHubPullRequestReviewCommentSide>;
};

/** Details about a repository as it appears on GitHub (Open API `repository`) */
export type GithubRepo = {
  /** Whether the GitHub App is installed for the repository */
  appInstalled: Scalars['Boolean'];
  /** Current users's access to the GitHub repo */
  authorization: GithubRepoAuthorization;
  /** Full repository name, e.g. owner/name */
  fullName: Scalars['String'];
  /** Integer ID from GitHub */
  id: Scalars['ID'];
  /** Short repository name */
  name: Scalars['String'];
  /** Owning user or organization */
  owner: GithubOrganization;
  /** Whether this repository is marked as private */
  private: Scalars['Boolean'];
  /** ISO 8601 datetime */
  pushedAt?: Maybe<Scalars['String']>;
  /** ISO 8601 datetime */
  updatedAt: Scalars['String'];
};

export enum GithubRepoAuthorization {
  Read = 'READ',
  Write = 'WRITE'
}

/**
 * Information about a GitHub user who has been requested to review
 * a pull request and its associated CSB user if available
 */
export type GithubRequestedReviewer = {
  /** Timestamp that the user was last requested to review this PR */
  requestedAt?: Maybe<Scalars['DateTime']>;
  /** CodeSandbox user associated with this GitHub account, if available */
  user?: Maybe<User>;
  /** GitHub username */
  username: Scalars['String'];
};

/** Information about a GitHub organization team. Currently very limited, but hopefully we can include member information in the future */
export type GithubRequestedTeam = {
  name: Scalars['String'];
  /** Timestamp that the team was last requested to review this PR */
  requestedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageReference = {
  fileName: Scalars['String'];
  resolution: Array<Scalars['Int']>;
  src?: InputMaybe<Scalars['Base64']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ImageReferenceMetadata = {
  fileName: Scalars['String'];
  resolution: Array<Scalars['Int']>;
  uploadId: Scalars['UUID4'];
  url: Scalars['String'];
};

/** GitHub webhook event about the status of a GitHub App installation. */
export type InstallationEvent = {
  action: InstallationEventAction;
  event: Scalars['String'];
};

export enum InstallationEventAction {
  Created = 'CREATED'
}

/** An invitation to a sandbox */
export type Invitation = {
  authorization: Authorization;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  sandbox: Sandbox;
  token: Scalars['String'];
};

export type InvoicePreview = {
  total: Scalars['Int'];
  totalExcludingTax?: Maybe<Scalars['Int']>;
  updateMoment?: Maybe<SubscriptionUpdateMoment>;
};

/** Information about the last commit made by CodeSandbox for a project or branch */
export type LastCommit = {
  color: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  sha: Scalars['String'];
  timestamp: Scalars['String'];
  user?: Maybe<User>;
};

export type Limits = {
  personalFree: TeamLimits;
  personalPro: TeamLimits;
  teamFree: TeamLimits;
  teamPro: TeamLimits;
};

/**
 * Live session started by an editor of a cloud sandbox for the benefit of guest users
 *
 * In a live session, there are editors (people who naturally have write access to the content)
 * and guests (a superset that includes editors and other individuals who join the live session).
 * Editors always have write permission, while non-editor guests have permissions determined by
 * the default level-of-access or an individual override for that particular user. See mutations
 * `setLiveSessionDefaultPermission` and `setLiveSessionGuestPermission` for more information.
 */
export type LiveSession = {
  /**
   * Default level of access for non-editor guests
   *
   * Editors of the cloud sandbox can change this using the `setLiveSessionDefaultPermission`
   * mutation.
   */
  defaultPermission: LiveSessionPermission;
  /**
   * Guests of a live session
   *
   * This list includes all non-editor guests, regardless of their level of access. Users who have
   * natural write access to the content will not appear here.
   */
  guests: Array<LiveSessionGuest>;
  /** User that started the live session */
  host?: Maybe<LiveSessionHost>;
  /** Session identifier, used for client-side caching */
  id: Scalars['ID'];
  /** Timestamp of the time when the live session opened (ISO 8601) */
  startedAt: Scalars['String'];
  /**
   * Timestamp of the time when the live session ended (ISO 8601)
   *
   * In practice, this field will only be visible in response to a `stopLiveSession` mutation or
   * as the final message of a `liveSessionEvents` subscription.
   */
  stoppedAt?: Maybe<Scalars['String']>;
  /** ID of the related sandbox VM */
  vmId: Scalars['ID'];
};

/** Change to a live session emitted by the `liveSessionEvents` subscription */
export type LiveSessionEvent = {
  /** Action that emitted the event */
  event: LiveSessionEventAction;
  /** Current state of the live session */
  session: LiveSession;
};

/** Actions that may emit a live session event */
export enum LiveSessionEventAction {
  Joined = 'JOINED',
  SetDefaultPermission = 'SET_DEFAULT_PERMISSION',
  SetGuestPermission = 'SET_GUEST_PERMISSION',
  Started = 'STARTED',
  Stopped = 'STOPPED'
}

/**
 * Guest of a live session
 *
 * This record represents a non-editor guest of a live session.
 */
export type LiveSessionGuest = {
  /** URL of the user's avatar image */
  avatarUrl: Scalars['String'];
  /** Level of access for the guest */
  permission: LiveSessionPermission;
  /** CodeSandbox user ID */
  userId: Scalars['ID'];
  /** CodeSandbox username */
  username: Scalars['String'];
};

/**
 * Hose of a live session
 *
 * This user initially started the live session.
 */
export type LiveSessionHost = {
  /** URL of the user's avatar image */
  avatarUrl: Scalars['String'];
  /** CodeSandbox user ID */
  userId: Scalars['ID'];
  /** CodeSandbox username */
  username: Scalars['String'];
};

/** Level of access for a live session */
export enum LiveSessionPermission {
  Read = 'READ',
  Write = 'WRITE'
}

export type MemberAuthorization = {
  authorization: TeamMemberAuthorization;
  teamManager?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['UUID4'];
};

export type Notification = {
  archived: Scalars['Boolean'];
  data: Scalars['String'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['NaiveDateTime'];
  read: Scalars['Boolean'];
  type: Scalars['String'];
};

export type NotificationPreferences = {
  emailCommentMention: Scalars['Boolean'];
  emailCommentReply: Scalars['Boolean'];
  /**
   * Whether or not a user wants to receive marketing emails.
   * Since we do not receive webhooks from the marketing email service, it is possible for this to show
   * `true` when in reality a user has already unsubscribed via the link in an email.
   * This is inevitable, but does not affect whether or not they get emails.
   */
  emailMarketing: Scalars['Boolean'];
  emailNewComment: Scalars['Boolean'];
  emailSandboxInvite: Scalars['Boolean'];
  emailTeamInvite: Scalars['Boolean'];
  emailTeamRequest: Scalars['Boolean'];
  /**
   * Whether or not a user wants an in-browser notification if someone submits a review on their PR.
   *
   * This will only be sent when a repository has the GitHub App installed and the PR owner is a
   * member of a CodeSandbox team that has the project imported.
   */
  inAppPrReviewReceived: Scalars['Boolean'];
  /**
   * Whether or not a user wants an in-browser notification if someone requests their review on a PR.
   *
   * This will only be sent when a repository has the GitHub App installed and the requested reviewer is a
   * member of a CodeSandbox team that has the project imported.
   */
  inAppPrReviewRequest: Scalars['Boolean'];
};

export type OrderBy = {
  direction: Direction;
  field: Scalars['String'];
};

export type PreviewReference = {
  height: Scalars['Int'];
  previewPath: Scalars['String'];
  screenshotSrc?: InputMaybe<Scalars['Base64']>;
  userAgent: Scalars['String'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type PreviewReferenceMetadata = {
  height: Scalars['Int'];
  previewPath: Scalars['String'];
  screenshotUrl?: Maybe<Scalars['String']>;
  userAgent: Scalars['String'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

/** A private package registry */
export type PrivateRegistry = {
  authType?: Maybe<AuthType>;
  enabledScopes: Array<Scalars['String']>;
  id: Scalars['UUID4'];
  limitToScopes?: Maybe<Scalars['Boolean']>;
  proxyEnabled?: Maybe<Scalars['Boolean']>;
  registryAuthKey?: Maybe<Scalars['String']>;
  registryType: RegistryType;
  registryUrl?: Maybe<Scalars['String']>;
  sandpackTrustedDomains: Array<Scalars['String']>;
  teamId: Scalars['UUID4'];
};

export type ProSubscription = {
  active: Scalars['Boolean'];
  billingInterval?: Maybe<SubscriptionInterval>;
  cancelAt?: Maybe<Scalars['DateTime']>;
  cancelAtPeriodEnd: Scalars['Boolean'];
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  nextBillDate?: Maybe<Scalars['DateTime']>;
  origin?: Maybe<SubscriptionOrigin>;
  /** Whether or not this subscription has a payment method attached to it. It will almost always be true, except when a team started a trial without a credit card and has not yet added one. */
  paymentMethodAttached: Scalars['Boolean'];
  paymentProvider?: Maybe<SubscriptionPaymentProvider>;
  quantity?: Maybe<Scalars['Int']>;
  status: SubscriptionStatus;
  trialEnd?: Maybe<Scalars['DateTime']>;
  trialStart?: Maybe<Scalars['DateTime']>;
  type: SubscriptionType;
  /** Per-seat price for the billing interval as an integer of the smallest denomination of the local currency. */
  unitPrice?: Maybe<Scalars['Int']>;
  updateBillingUrl?: Maybe<Scalars['String']>;
};

/**
 * Repository imported to a CodeSandbox team.
 *
 * Projects represent a git repository that has been imported to CodeSandbox for collaboration in a
 * specific team. The assigned team is given by the `team` field. If no `team` is assigned, then the
 * project is a read-only placeholder for anonymous users.
 *
 * A project `id` is unique to the repository-team pair, and should be used any time it is known.
 * If the project is not known, then the repository `owner`/`name` pair, along with the team `id`,
 * is roughly equivalent.
 *
 * To import a project, see the `importProject` mutation.
 */
export type Project = {
  /** Whether the CodeSandbox GitHub App is installed */
  appInstalled: Scalars['Boolean'];
  /**
   * Combined permission of the current user on this project
   *
   * This includes permissions granted by the git provider, team membership, and any usage limits
   * faced by the team. This field may be requested even for anonymous users, but the value will
   * always be READ (or the project itself will fail to resolve).
   */
  authorization: ProjectAuthorization;
  /**
   * Get a CodeSandbox branch related to a particular Project by name
   *
   * Projects related to the same Repository may have different branches in CodeSandbox. Some
   * branches may have been created in CodeSandbox and not yet pushed to the Git provider, and some
   * may have been imported from the Git provider for some workspaces but not others.
   *
   * This field will look for a branch, by name, specifically related to the parent Project. If the
   * branch does not exist for the parent Project, it will return `null`.
   *
   * Contribution branches are not supported by this field.
   */
  branchByName?: Maybe<Branch>;
  /** Number of branches imported to CodeSandbox for this project. It is asynchronously updated when a create or delete happens. */
  branchCount: Scalars['Int'];
  /** Repository branches that have been imported to (or created in) CodeSandbox */
  branches: Array<Branch>;
  /** Active users connected to a branch of this project */
  connections: Array<Connection>;
  /** Shortcut to retrieve the repository's default branch as it appears on CodeSandbox */
  defaultBranch: Branch;
  /** CodeSandbox ID for the project (specific to this repository-team pair) */
  id: Scalars['ID'];
  /** Timestamp of the last time the current user accessed one of this project's branches on CodeSandbox */
  lastAccessedAt?: Maybe<Scalars['String']>;
  /** Information about the last commit made by CodeSandbox on any branch */
  lastCommit?: Maybe<LastCommit>;
  /** Open pull requests from head branches in this repository */
  pullRequests: Array<PullRequest>;
  /** Git repository for the project, as it appears on the original git provider */
  repository: Repository;
  /** Compute resources for the project, based on settings and team subscription */
  resources: Resources;
  /** Settings for the project */
  settings: ProjectSettings;
  /**
   * Team to which this project is assigned
   *
   * If `null`, the project is read-only. Loading only the `id` of the team is optimized to avoid
   * unnecessary queries. Loading any field other than the `id` will incur the additional cost of
   * looking up the team.
   */
  team?: Maybe<Team>;
};


/**
 * Repository imported to a CodeSandbox team.
 *
 * Projects represent a git repository that has been imported to CodeSandbox for collaboration in a
 * specific team. The assigned team is given by the `team` field. If no `team` is assigned, then the
 * project is a read-only placeholder for anonymous users.
 *
 * A project `id` is unique to the repository-team pair, and should be used any time it is known.
 * If the project is not known, then the repository `owner`/`name` pair, along with the team `id`,
 * is roughly equivalent.
 *
 * To import a project, see the `importProject` mutation.
 */
export type ProjectBranchByNameArgs = {
  name: Scalars['String'];
};

/** Combined permission for a project including git provider, team membership, and usage limits */
export enum ProjectAuthorization {
  Admin = 'ADMIN',
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE'
}

/** Events related to a project (repository). */
export type ProjectEvent = PullRequestCommentEvent | PullRequestEvent | PullRequestReviewCommentEvent | PullRequestReviewEvent;

/** User-editable settings for a project */
export type ProjectSettings = {
  /** Whether AI features are explicitly enabled or disabled for this project. If `null`, the team-wide setting applies. */
  aiConsent?: Maybe<Scalars['Boolean']>;
};

/** The oAuth provider used to create the account */
export enum ProviderName {
  Apple = 'APPLE',
  Github = 'GITHUB',
  Google = 'GOOGLE'
}

/** Pull Request as it appears on GitHub */
export type PullRequest = {
  /** Number of code additions in this PR. Only available for GHA repositories. */
  additions?: Maybe<Scalars['Int']>;
  /** Destination branch of this pull request. */
  baseBranch: Scalars['String'];
  /** Destination repository of the pull request (may not be the same as the HEAD) */
  baseRepository: Repository;
  /** Body (description) of the pull request */
  body?: Maybe<Scalars['String']>;
  /** Number of changed files in this PR. Only available for GHA repositories. */
  changedFiles?: Maybe<Scalars['Int']>;
  /** Comments that are not part of a PR review */
  comments: Array<GitHubPullRequestComment>;
  /** Number of comments on this PR. Only available for GHA repositories. */
  commentsCount?: Maybe<Scalars['Int']>;
  /** Number of commits on this PR. Only available for GHA repositories. */
  commitsCount?: Maybe<Scalars['Int']>;
  /** If available, the CodeSandbox user who opened the PR */
  creator?: Maybe<User>;
  /** GitHub username of the person who opened the PR */
  creatorUsername: Scalars['String'];
  /** Number of code deletions in this PR. Only available for GHA repositories. */
  deletions?: Maybe<Scalars['Int']>;
  /** Whether the PR is marked as a draft (instead of ready for review) */
  draft: Scalars['Boolean'];
  /** The name of the HEAD branch of this PR. This is the branch containing the changes */
  headBranch: Scalars['String'];
  /** URL to view the PR on GitHub */
  htmlUrl: Scalars['String'];
  /** Whether the PR can be merged in terms of Git conflicts. See also `mergeable_state`. */
  mergeable?: Maybe<Scalars['Boolean']>;
  /** Whether the PR is allowed to be merged on GitHub */
  mergeableStatus?: Maybe<Scalars['String']>;
  /** PR number as it appears on GitHub */
  number: Scalars['Int'];
  /** When a PR was closed, either due to closing or merging */
  prClosedAt?: Maybe<Scalars['DateTime']>;
  /** When a PR was originally opened */
  prCreatedAt?: Maybe<Scalars['DateTime']>;
  /** When a PR was merged */
  prMergedAt?: Maybe<Scalars['DateTime']>;
  /** When information about a PR was last changed */
  prUpdatedAt: Scalars['DateTime'];
  /** Information about users who have been requested to review this PR. */
  requestedReviewers: Array<GithubRequestedReviewer>;
  /** Information about teams who have been requested to review this PR. */
  requestedTeams: Array<GithubRequestedTeam>;
  /** Number of review comments on this PR. Only available for GHA repositories. */
  reviewCommentsCount?: Maybe<Scalars['Int']>;
  /** Information about reviews that have been submitted for this PR. */
  reviews: Array<PullRequestReview>;
  /** Current state of the pull request (ex. `open` or `closed`) */
  state: Scalars['String'];
  /** Title of the PR as it appears on GitHub */
  title: Scalars['String'];
};

/**
 * Event about a comment on a pull request (outside the context of a review)
 *
 * GitHub does not distinguish between PR and issue comments, so the event will be "issue_comment"
 * for both types. The API will attempt to distinguish between them using additional information
 * from the event.
 */
export type PullRequestCommentEvent = {
  action: PullRequestCommentEventAction;
  comment: GitHubPullRequestComment;
  event: Scalars['String'];
  /**
   * Pull request on which the comment appears
   *
   * This field is nullable due to an edge case that may cause comments to be saved without the
   * parent PR. Clients can observe the comment's `issueId` field to see if the pull request is
   * already known based on its ID.
   */
  pullRequest?: Maybe<PullRequest>;
};

export enum PullRequestCommentEventAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Edited = 'EDITED'
}

/** Event about activity on a pull request */
export type PullRequestEvent = {
  action: PullRequestEventAction;
  event: Scalars['String'];
  pullRequest: PullRequest;
};

export enum PullRequestEventAction {
  Closed = 'CLOSED',
  ConvertedToDraft = 'CONVERTED_TO_DRAFT',
  Opened = 'OPENED',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReviewRequested = 'REVIEW_REQUESTED',
  ReviewRequestRemoved = 'REVIEW_REQUEST_REMOVED'
}

/** Pull Request review */
export type PullRequestReview = {
  body?: Maybe<Scalars['String']>;
  /**
   * Comments on the PR review
   *
   * Comments are returned in the order in which they were created. However, clients may wish to
   * observe the `is_reply_to_id` field to ensure threaded replies appear in order.
   */
  comments: Array<GitHubPullRequestReviewComment>;
  id: Scalars['Int'];
  state: PullRequestReviewState;
  submittedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last time the review was persisted to the DB. Null means it has not been yet persisted */
  syncedAt?: Maybe<Scalars['DateTime']>;
  /** If available, the CodeSandbox user who submitted the review */
  user?: Maybe<User>;
  /** GitHub username of the user who submitted the review */
  username: Scalars['String'];
};

/** Event about a comment on a pull request review */
export type PullRequestReviewCommentEvent = {
  action: PullRequestReviewCommentEventAction;
  comment: GitHubPullRequestReviewComment;
  event: Scalars['String'];
  pullRequest: PullRequest;
};

export enum PullRequestReviewCommentEventAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Edited = 'EDITED'
}

/** Event about review activity on a pull request */
export type PullRequestReviewEvent = {
  action: PullRequestReviewEventAction;
  event: Scalars['String'];
  pullRequest: PullRequest;
  review: PullRequestReview;
};

export enum PullRequestReviewEventAction {
  Dismissed = 'DISMISSED',
  Edited = 'EDITED',
  Submitted = 'SUBMITTED'
}

/** Current state of a GitHub pull request review */
export enum PullRequestReviewState {
  Approved = 'APPROVED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Commented = 'COMMENTED',
  Dismissed = 'DISMISSED'
}

export type Reference = {
  id: Scalars['UUID4'];
  metadata: ReferenceMetadata;
  resource: Scalars['String'];
  type: Scalars['String'];
};

/** The metadata of a reference */
export type ReferenceMetadata = CodeReferenceMetadata | ImageReferenceMetadata | PreviewReferenceMetadata | UserReferenceMetadata;

export enum RegistryType {
  Custom = 'CUSTOM',
  Github = 'GITHUB',
  Npm = 'NPM'
}

/** Repository as seen on one of our git providers */
export type Repository = GitHubRepository;

/** GitHub webhook event about a repository. */
export type RepositoryEvent = InstallationEvent;

/**
 * Available computing resources for the project
 *
 * These resources may be custom for a project, or they may be determined by the team's subscription.
 */
export type Resources = {
  /** CPU core count */
  cpu: Scalars['Int'];
  /** RAM in Gi */
  memory: Scalars['Int'];
  /** Disk space in Gi */
  storage: Scalars['Int'];
};

export type RootMutationType = {
  /** Accept an invitation to a team */
  acceptTeamInvitation: Team;
  /** Add a collaborator */
  addCollaborator: Collaborator;
  /** Add sandboxes to an album (idempotent) */
  addSandboxesToAlbum?: Maybe<Album>;
  /** Add sandboxes to a collection */
  addToCollection: Collection;
  /** Add sandboxes to a collection and/or team */
  addToCollectionOrTeam: Array<Maybe<Sandbox>>;
  /** Archive all notifications */
  archiveAllNotifications: User;
  /** Archive one notification */
  archiveNotification: Notification;
  /** bookmark a template */
  bookmarkTemplate?: Maybe<Template>;
  /** Cancel deletion of current user */
  cancelDeleteCurrentUser: Scalars['String'];
  /** Change authorization of a collaborator */
  changeCollaboratorAuthorization: Collaborator;
  changeSandboxInvitationAuthorization: Invitation;
  /** Set team member authorization levels */
  changeTeamMemberAuthorizations: Team;
  /** Clear notification unread count */
  clearNotificationCount: User;
  /**
   * Convert an existing subscription to usage-based billing
   *
   * This mutation requires the caller to be an admin of the team. Otherwise, an error will be
   * returned `"Not an admin"`. This return value will always be `true`. Clients should observe
   * the `teamEvents` subscription for updates to the workspace subscription.
   */
  convertToUsageBilling: Scalars['Boolean'];
  createAlbum: Album;
  /**
   * Create or import a branch to a team-associated project
   *
   * This endpoint allows users to create a new branch on CodeSandbox. The branch may already exist
   * in the git provider, or not. Depending on the user's level of access to the repository, the
   * branch could be a _contribution branch_, which will automatically fork a new repository and
   * project on the first commit.
   *
   * A team ID is required for this mutation. To import an existing branch into a read-only project
   * that is not team-associated, see `mutation importReadOnlyBranch`.
   *
   * Example (for `codesandbox/test-repo` branch `test-branch`):
   *
   * ```gql
   * mutation createBranch(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   team: "ebfeb17e-3301-4069-a476-447b2fcb525c",
   *   branch: "test-branch"
   * ) { id }
   * ```
   */
  createBranch: Branch;
  createCodeComment: Comment;
  /** Create a collection */
  createCollection: Collection;
  createComment: Comment;
  /**
   * Create a contribution branch on a non-team-assinged project.
   *
   * This endpoint allows users to create a contribution branch on a read-only project. This branch will only be created on CodeSandbox and the branch will be a _contribution branch_, which will automatically fork a new repository andproject on the first commit.
   *
   * A team ID is not accepted for this mutation. To create a branch on a team-assigned project, see `mutation createBranch`.
   *
   * Example (for `codesandbox/test-repo` branch `test-branch`):
   *
   * ```gql
   * mutation createContributionBranch(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   * ) { id }
   * ```
   */
  createContributionBranch: Branch;
  /**
   * Create a review on a pull request on GitHub.
   *
   * Requires a signed-in user who has granted additional GitHub permissions. Returns the updated
   * pull request review. Clients should be prepared to receive the same or additional information
   * from the `BranchEvents` or `ProjectEvents` subscription with a `PullRequestReviewEvent` once
   * the GitHub webhook is processed.
   */
  createGithubPullRequestReview: PullRequestReview;
  /** Create or Update a private registry */
  createOrUpdatePrivateNpmRegistry: PrivateRegistry;
  createPreviewComment: Comment;
  createSandboxInvitation: Invitation;
  /** Create a team */
  createTeam: Team;
  deleteAlbum: Scalars['String'];
  /**
   * Remove a branch from CodeSandbox
   *
   * Does not affect other copies of the same branch related to projects in other teams, and does
   * not affect the branch in the git provider. The branch VM will be archived, possibly losing
   * uncommitted work-in-progress.
   *
   * Returns the scalar `true` on success, and errors otherwise.
   *
   * Example (for branch with short ID `abc123`)
   *
   * ```gql
   * mutation deleteBranch(id: "abc123")
   * ```
   */
  deleteBranch: Scalars['Boolean'];
  /** Delete a collection and all subfolders */
  deleteCollection: Array<Collection>;
  /** Soft delete a comment. Note: all child comments will also be deleted. */
  deleteComment: Comment;
  /**
   * Request deletion of current user
   *
   * This mutation does not immediately delete the current user, but instead schedules the deletion
   * for some time in the next 24 hours. Users have an opportunity to cancel the deletion request
   * using `mutation cancelDeleteCurrentUser`.
   *
   * There are three situations in which this mutation will fail:
   *
   * 1. If no user is currently authenticated
   * 2. If the user is the only admin to a team that has other members
   * 3. If the user is an admin of a team with an active subscription or trial
   *
   * The third situation can be ignored by passing `true` to the argument `confirm`. It is intended
   * that users may try to delete once, read the error message, and then check a box to confirm
   * their choice and submit again.
   *
   * **Note**: If not supplied, `confirm` is automatically `true` for backwards compatibility.
   *
   * ## Examples
   *
   * For a first attempt at deletion, use `confirm: false`.
   *
   * ```gql
   * deleteCurrentUser(confirm: false)
   * ```
   *
   * This will return successful if the user does not meet any of the failure criteria listed
   * above. Otherwise, one of the following errors will be returned:
   *
   * * `Please log in`
   * * `You are the only admin of a team. Please designate another admin or delete the following teams: ...`
   * * `You have active subscription(s) on the following teams: ... Are you sure you want to remove your account?`
   *
   * For the last error, if the user confirms their desire to delete the account, use
   * `confirm: true` to bypass the final check. In this case, only these two errors will occur:
   *
   * * `Please log in`
   * * `You are the only admin of a team. Please designate another admin or delete the following teams: ...`
   */
  deleteCurrentUser: Scalars['String'];
  /**
   * Delete a comment from a pull request review
   *
   * Requires a signed-in user who has granted additional GitHub permissions. This endpoint returns
   * a simple message, since the original comment was deleted. Clients can expect an event on the
   * `BranchEvents` and `ProjectEvents` subscriptions with the full body of the removed comment.
   */
  deleteGithubPullRequestReviewComment: Scalars['String'];
  /** Delete a private registry */
  deletePrivateNpmRegistry?: Maybe<PrivateRegistry>;
  /**
   * Remove a project from CodeSandbox
   *
   * Does not affect other copies of the project related to the same repository in other teams, and
   * does not affect the repository in the git provider. Branches related to the project will be
   * removed, potentially losing uncommitted work-in-progress.
   *
   * Returns the scalar `true` on success, and errors otherwise.
   *
   * Example (for `https://github.com/codesandbox/test-repo.git`)
   *
   * ```gql
   * mutation deleteProject(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   team: "0fd70d0b-7642-4426-a8b3-38ee18c7c9cc"
   * )
   * ```
   */
  deleteProject: Scalars['Boolean'];
  /**
   * Remove a project from CodeSandbox using its CodeSandbox ID
   *
   * Unlike `mutation deleteProject`, this mutation supports deleting projects related to a
   * repository that has been deleted and recreated with the same name. Otherwise, a matching
   * project related to the latest known instance of a repository will be deleted.
   *
   * The target project must be team-assigned, and the user must have write access on that team.
   *
   * Does not affect other copies of the project related to the same repository in other teams, and
   * does not affect the repository in the git provider. Branches related to the project will be
   * removed, potentially losing uncommitted work-in-progress.
   *
   * Returns the scalar `true` on success, and errors otherwise.
   *
   * Example:
   *
   * ```gql
   * mutation deleteProject(id: "9ff91681-5ae9-452c-abaa-f9bf7033d82c")
   * ```
   */
  deleteProjectById: Scalars['Boolean'];
  /** Delete sandboxes */
  deleteSandboxes: Array<Sandbox>;
  deleteWorkspace: Scalars['String'];
  /**
   * Dismiss a submitted pull request review
   *
   * Requires a signed-in user who has granted additional GitHub permissions. Returns the updated
   * pull request review. Clients should be prepared to receive the same or additional information
   * from the `BranchEvents` or `ProjectEvents` subscription with a `PullRequestReviewEvent` once
   * the GitHub webhook is processed.
   *
   * **Note**: To dismiss a pull request review on a protected branch, the user must be a
   * repository administrator or be included in the list of people or teams who can dismiss pull
   * request reviews.
   */
  dismissGithubPullRequestReview: PullRequestReview;
  /**
   * Import an existing branch from a repository
   *
   * This endpoint allows users to import an existing branch from the git provider to CodeSandbox.
   * To create a new branch on CodeSandbox that may not exist on the git provider, see `mutation
   * createBranch`.
   *
   * A team ID is required for this mutation. To import an existing branch into a read-only project
   * that is not team-associated, see `mutation importReadOnlyBranch`.
   *
   * Example (for `codesandbox/test-repo` branch `test-branch`):
   *
   * ```gql
   * mutation importBranch(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   branch: "test-branch",
   *   team: "3e0a6cf9-af9c-4a7f-b4fb-1b2040e24a86"
   * ) { id }
   * ```
   */
  importBranch: Branch;
  /**
   * Import a repository to a specific team
   *
   * This endpoint should be called when a signed-in user **explicitly** wants to import a
   * Repository. It will have immediate effect on the team's usage limits. For implicit loading of a
   * project, see the `project` top-level query. For importing a read-only project for a public
   * repository, see the `importReadOnlyProject` mutation.
   *
   * Example (for `https://github.com/codesandbox/test-repo.git`)
   *
   * ```gql
   * mutation importProject(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   team: "0fd70d0b-7642-4426-a8b3-38ee18c7c9cc"
   * ) { id }
   * ```
   */
  importProject: Project;
  /**
   * Import an existing branch from a public repository
   *
   * Anonymous users and users without git credentials may only view branches that exist in the git
   * provider. This endpoint allows users to import such a branch to the read-only copy of a project.
   * See `mutation createBranch` for creating a new branch on a user-writable project.
   *
   * Example (for `codesandbox/test-repo` branch `test-branch`):
   *
   * ```gql
   * mutation importReadOnlyBranch(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   branch: "test-branch"
   * ) { id }
   * ```
   */
  importReadOnlyBranch: Branch;
  /**
   * Import a public repository as a read-only project
   *
   * This endpoint should be called when a user **explicitly** wants to import a Repository. The
   * repository must be public. For importing private repositories, or importing a repository to
   * a specific team for editing, see the `importProject` mutation.
   *
   * Example (for `https://github.com/codesandbox/test-repo.git`)
   *
   * ```gql
   * mutation importReadOnlyProject(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo"
   * ) { id }
   * ```
   */
  importReadOnlyProject: Project;
  /** Increments the sandbox version and marks its screenshot as outdated. Requires `write_code` permission or above. */
  incrementSandboxVersion: Scalars['String'];
  /** Invite someone to a team */
  inviteToTeam: Team;
  /** Invite someone to a team via email */
  inviteToTeamViaEmail: Scalars['String'];
  /**
   * Join a workspace the user is eligible to join based on email domain
   *
   * A list of eligible workspaces (and their IDs) is available from the `me > eligibleWorkspaces`
   * query. This endpoint requires an authenticated user and an eligible workspace ID. Otherwise,
   * one of the following errors will be returned:
   *
   * * `Please log in`
   * * `Workspace not found`
   *
   * The latter error represents both invalid IDs and ineligible workspaces.
   */
  joinEligibleWorkspace: Team;
  /**
   * Join an existing live session
   *
   * Accessible to non-editor guests for content that has an existing live session. For editors,
   * this mutation is a no-op. Returns an error if no live session exists.
   */
  joinLiveSession: LiveSession;
  /**
   * Join the usage-based billing beta on-demand
   *
   * This mutation requires the caller to be an admin of the team. Otherwise, an error will be
   * returned `"Not an admin"`. The return value will always be `true`.
   */
  joinUsageBillingBeta: Scalars['Boolean'];
  /** Leave a team */
  leaveTeam: Scalars['String'];
  /** Make templates from sandboxes */
  makeSandboxesTemplates: Array<Template>;
  /** Mark all notifications as read */
  markAllNotificationsAsRead: User;
  /** Mark one notification as read */
  markNotificationAsRead: Notification;
  /**
   * Merge a pull request if merging is possible
   *
   * Pull requests have `mergeable` and `mergeableState` fields that indicate whether they can be
   * merged (due to git conflicts and other merge requirements). However, these fields may not be
   * up-to-date. Before attempting to merge, this mutation will check the latest status and return
   * an error if merging is not possible. Furthermore, it will publish an event for the related
   * repository and branch with the updated status.
   *
   * On success, the project and branch subscriptions will receive the updated pull request as soon
   * as the resulting webhook is received.
   */
  mergeGithubPullRequest: Scalars['String'];
  permanentlyDeleteSandboxes: Array<Sandbox>;
  /**
   * See proposed invoice for converting from seat-based to usage-based billing
   *
   * This mutation requires the caller to be an admin of the team. Otherwise, an error will be
   * returned `"Not an admin"`. Why a mutation? This operation requires communicating information
   * with Stripe in a way that is more appropriate for a mutation than a query.
   */
  previewConvertToUsageBilling: InvoicePreview;
  /** @deprecated Subscription management no longer supported via GraphQL */
  previewUpdateSubscriptionBillingInterval: BillingPreview;
  previewUpdateUsageSubscriptionPlan: InvoicePreview;
  reactivateSubscription: ProSubscription;
  redeemSandboxInvitation: Invitation;
  /** Redeem an invite token from a team */
  redeemTeamInviteToken: Team;
  /** Reject an invitation to a team */
  rejectTeamInvitation: Scalars['String'];
  /** Remove a collaborator */
  removeCollaborator: Collaborator;
  /** Remove someone from a team */
  removeFromTeam: Team;
  /**
   * Remove one or more GH users from the list of requested reviewers for this pull request.
   * Returns the list of users that are still requested to review.
   */
  removeRequestedGithubPullRequestReviewers: Array<GithubRequestedReviewer>;
  /** Remove sandboxes from album (idempotent) */
  removeSandboxesFromAlbum?: Maybe<Album>;
  /** Rename a collection and all subfolders */
  renameCollection: Array<Collection>;
  renameSandbox: Sandbox;
  /**
   * Reply to a pull request review on GitHub
   *
   * Requires a signed-in user who has granted additional GitHub permissions. This mutation returns
   * only "OK" or an error message. To receive the created review data, the GitHub app needs to be
   * installed in the repository, and clients need to subscribe to `BranchEvents` or
   * `ProjectEvents` which will receive a `PullRequestReviewCommentEvent` once the webhook from
   * GitHub gets processed.
   */
  replyToGithubPullRequestReview: GitHubPullRequestReviewComment;
  /**
   * Request one or more GH users to review a pull request
   * Returns complete list of users  requested to review.
   */
  requestGithubPullRequestReviewers: Array<GithubRequestedReviewer>;
  /**
   * Request access to a team by ID
   *
   * This will notify admins of the team that the current user would like to join the team. It is
   * up to the team admins to complete the process. A simple message for the user is returned.
   *
   * ```gql
   * mutation requestTeamInvitation(teamId: "61cbc936-470c-48f9-9520-2b862493e0d8")
   * ```
   */
  requestTeamInvitation: Scalars['String'];
  resolveComment: Comment;
  revokeSandboxInvitation: Invitation;
  /** Revoke an invitation to a team */
  revokeTeamInvitation: Team;
  setBranchProtection: Branch;
  /** Set the default authorization for any new members joining this workspace */
  setDefaultTeamMemberAuthorization: WorkspaceSandboxSettings;
  /**
   * Set the default level of access for guests in a live session
   *
   * Accessible to editors of the underlying content.
   *
   * With a default permission of `READ`, guests join with the ability to read the code and watch
   * changes taking place without making changes of their own, like a classroom mode. With `WRITE`,
   * all new guests will be able to make changes immediately.
   *
   * Individual guest permissions can be overridden using the `setLiveSessionGuestPermission`
   * mutation. Changing the default permission does not reset any individual guest permissions
   * set using the `setLiveSessionGuestPermission` mutation. It also does not affect editors (those
   * who naturally have access to the content).
   */
  setLiveSessionDefaultPermission: LiveSession;
  /**
   * Set the level of access for a specific guest in a live session
   *
   * Accessible to editors of the underlying content.
   *
   * If an individual guest should have a level of access different than the default permission
   * set using the `setLiveSessionDefaultPermission` mutation, this mutation allows targeted
   * access. It has no effect on editors (those who naturally have access to the content).
   */
  setLiveSessionGuestPermission: LiveSession;
  setPreventSandboxesExport: Array<Sandbox>;
  setPreventSandboxesLeavingWorkspace: Array<Sandbox>;
  /** Change the primary workspace for the current user */
  setPrimaryWorkspace: Scalars['String'];
  setSandboxesFrozen: Array<Sandbox>;
  setSandboxesPrivacy: Array<Sandbox>;
  /** Configure consent for AI features in this team. Can be overridden for specific repositories or sandboxes. */
  setTeamAiConsent: TeamAiConsent;
  /** Set the description of the team */
  setTeamDescription: Team;
  /** Set user-editable limits for the workspace */
  setTeamLimits: Scalars['String'];
  /** Set user-provided metadata about the workspace */
  setTeamMetadata: Team;
  /** Set minimum privacy level for workspace */
  setTeamMinimumPrivacy: WorkspaceSandboxSettings;
  /** Set the name of the team */
  setTeamName: Team;
  setWorkspaceSandboxSettings: WorkspaceSandboxSettings;
  softCancelSubscription: ProSubscription;
  /**
   * Begin a new live session for a running VM
   *
   * Accessible to editors of the underlying content as long as live sessions are allowed by the
   * content and its workspace.
   *
   * The live session will be automatically stopped a few minutes after the VM session ends, or
   * immediately after calling the `stopLiveSession` mutation.
   */
  startLiveSession: LiveSession;
  /**
   * Immediately close a live session
   *
   * Accessible to editors of the underlying content.
   */
  stopLiveSession: LiveSession;
  /** Unbookmark a template */
  unbookmarkTemplate?: Maybe<Template>;
  /** Convert templates back to sandboxes */
  unmakeSandboxesTemplates: Array<Template>;
  unresolveComment: Comment;
  updateAlbum: Album;
  updateComment: Comment;
  /** Change details of current user */
  updateCurrentUser: User;
  /** Edit the body of a pull request review. */
  updateGithubPullRequestReview: PullRequestReview;
  /**
   * Update a comment from a pull request review
   *
   * Requires a signed-in user who has granted additional GitHub permissions. This endpoint returns
   * the updated review comment. Clients can expect an event on the
   * `BranchEvents` and `ProjectEvents` subscriptions with the full body of the edited comment.
   */
  updateGithubPullRequestReviewComment: GitHubPullRequestReviewComment;
  /** Set a user's notification preferences */
  updateNotificationPreferences: NotificationPreferences;
  /** Update notification read status */
  updateNotificationReadStatus: Notification;
  /**
   * Update the settings for a project. All settings are nullable.
   * Not passing a specific argument will leave it unchanged, explicitly passing `null` will revert it to the default.
   */
  updateProjectSettings: ProjectSettings;
  /**
   * Update the VM tier of a project. All branches will start using this new VM tier as soon as the user connects
   * to the branch (also for running branches). To optimistically update a branch without reload/reconnect,
   * you can pass a branch ID as well that we'll update immediately.
   */
  updateProjectVmTier: Resources;
  /**
   * Update the settings for a sandbox. All settings are nullable.
   * Not passing a specific argument will leave it unchanged, explicitly passing `null` will revert it to the default.
   */
  updateSandboxSettings: SandboxSettings;
  /**
   * update subscription details (not billing details)
   * @deprecated Subscription management no longer supported via GraphQL
   */
  updateSubscription: ProSubscription;
  /** @deprecated Subscription management no longer supported via GraphQL */
  updateSubscriptionBillingInterval: ProSubscription;
  /**
   * Update addons for usage-based billing subscription.
   *
   * This mutation requires the caller to be an admin of the team. Otherwise, an error will be
   * returned `"Not an admin"`. This return value will always be `true`. Clients should observe
   * the `teamEvents` subscription for updates to the workspace subscription.
   *
   * After the upcoming pricing change anything other than an empty list to cancel all add-ons
   * will return an error.
   */
  updateUsageSubscription: Scalars['Boolean'];
  updateUsageSubscriptionPlan: Scalars['Boolean'];
};


export type RootMutationTypeAcceptTeamInvitationArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeAddCollaboratorArgs = {
  authorization: Authorization;
  sandboxId: Scalars['ID'];
  username: Scalars['String'];
};


export type RootMutationTypeAddSandboxesToAlbumArgs = {
  albumId: Scalars['ID'];
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeAddToCollectionArgs = {
  collectionPath: Scalars['String'];
  privacy?: InputMaybe<Scalars['Int']>;
  sandboxIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeAddToCollectionOrTeamArgs = {
  collectionPath?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['Int']>;
  sandboxIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeArchiveNotificationArgs = {
  notificationId: Scalars['UUID4'];
};


export type RootMutationTypeBookmarkTemplateArgs = {
  teamId?: InputMaybe<Scalars['UUID4']>;
  templateId: Scalars['UUID4'];
};


export type RootMutationTypeChangeCollaboratorAuthorizationArgs = {
  authorization: Authorization;
  sandboxId: Scalars['ID'];
  username: Scalars['String'];
};


export type RootMutationTypeChangeSandboxInvitationAuthorizationArgs = {
  authorization: Authorization;
  invitationId: Scalars['UUID4'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeChangeTeamMemberAuthorizationsArgs = {
  memberAuthorizations?: InputMaybe<Array<MemberAuthorization>>;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeConvertToUsageBillingArgs = {
  addons: Array<Scalars['String']>;
  billingInterval?: InputMaybe<SubscriptionInterval>;
  plan: Scalars['String'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeCreateAlbumArgs = {
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type RootMutationTypeCreateBranchArgs = {
  branch?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
  team: Scalars['ID'];
};


export type RootMutationTypeCreateCodeCommentArgs = {
  anchorReference: CodeReference;
  codeReferences?: InputMaybe<Array<CodeReference>>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  imageReferences?: InputMaybe<Array<ImageReference>>;
  parentCommentId?: InputMaybe<Scalars['ID']>;
  sandboxId: Scalars['ID'];
  userReferences?: InputMaybe<Array<UserReference>>;
};


export type RootMutationTypeCreateCollectionArgs = {
  path: Scalars['String'];
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeCreateCommentArgs = {
  codeReferences?: InputMaybe<Array<CodeReference>>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  imageReferences?: InputMaybe<Array<ImageReference>>;
  parentCommentId?: InputMaybe<Scalars['ID']>;
  sandboxId: Scalars['ID'];
  userReferences?: InputMaybe<Array<UserReference>>;
};


export type RootMutationTypeCreateContributionBranchArgs = {
  from?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
};


export type RootMutationTypeCreateGithubPullRequestReviewArgs = {
  body?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Array<GithubPullRequestReviewCommentInput>>;
  commitId?: InputMaybe<Scalars['String']>;
  event: GitHubPullRequestReviewAction;
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
};


export type RootMutationTypeCreateOrUpdatePrivateNpmRegistryArgs = {
  authType?: InputMaybe<AuthType>;
  enabledScopes: Array<Scalars['String']>;
  limitToScopes: Scalars['Boolean'];
  proxyEnabled: Scalars['Boolean'];
  registryAuthKey?: InputMaybe<Scalars['String']>;
  registryType: RegistryType;
  registryUrl?: InputMaybe<Scalars['String']>;
  sandpackTrustedDomains?: InputMaybe<Array<Scalars['String']>>;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeCreatePreviewCommentArgs = {
  anchorReference: PreviewReference;
  codeReferences?: InputMaybe<Array<CodeReference>>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  imageReferences?: InputMaybe<Array<ImageReference>>;
  parentCommentId?: InputMaybe<Scalars['ID']>;
  sandboxId: Scalars['ID'];
  userReferences?: InputMaybe<Array<UserReference>>;
};


export type RootMutationTypeCreateSandboxInvitationArgs = {
  authorization: Authorization;
  email: Scalars['String'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeCreateTeamArgs = {
  name: Scalars['String'];
  pilot?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeDeleteAlbumArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteBranchArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteCollectionArgs = {
  path: Scalars['String'];
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeDeleteCommentArgs = {
  commentId: Scalars['UUID4'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeDeleteCurrentUserArgs = {
  confirm?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeDeleteGithubPullRequestReviewCommentArgs = {
  commentId: Scalars['Int'];
  name: Scalars['String'];
  owner: Scalars['String'];
};


export type RootMutationTypeDeletePrivateNpmRegistryArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeDeleteProjectArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
  team: Scalars['ID'];
};


export type RootMutationTypeDeleteProjectByIdArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteSandboxesArgs = {
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeDeleteWorkspaceArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeDismissGithubPullRequestReviewArgs = {
  message: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
  pullRequestReviewId: Scalars['Int'];
};


export type RootMutationTypeImportBranchArgs = {
  branch: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
  team: Scalars['ID'];
};


export type RootMutationTypeImportProjectArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
  team: Scalars['ID'];
};


export type RootMutationTypeImportReadOnlyBranchArgs = {
  branch: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
};


export type RootMutationTypeImportReadOnlyProjectArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
};


export type RootMutationTypeIncrementSandboxVersionArgs = {
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeInviteToTeamArgs = {
  authorization?: InputMaybe<TeamMemberAuthorization>;
  teamId: Scalars['UUID4'];
  username: Scalars['String'];
};


export type RootMutationTypeInviteToTeamViaEmailArgs = {
  authorization?: InputMaybe<TeamMemberAuthorization>;
  email: Scalars['String'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeJoinEligibleWorkspaceArgs = {
  workspaceId: Scalars['ID'];
};


export type RootMutationTypeJoinLiveSessionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeJoinUsageBillingBetaArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeLeaveTeamArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeMakeSandboxesTemplatesArgs = {
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeMarkNotificationAsReadArgs = {
  notificationId: Scalars['UUID4'];
};


export type RootMutationTypeMergeGithubPullRequestArgs = {
  mergeMethod?: InputMaybe<GitHubPullRequestMergeMethod>;
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
};


export type RootMutationTypePermanentlyDeleteSandboxesArgs = {
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypePreviewConvertToUsageBillingArgs = {
  addons: Array<Scalars['String']>;
  billingInterval?: InputMaybe<SubscriptionInterval>;
  plan: Scalars['String'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypePreviewUpdateSubscriptionBillingIntervalArgs = {
  billingInterval: SubscriptionInterval;
  subscriptionId: Scalars['UUID4'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypePreviewUpdateUsageSubscriptionPlanArgs = {
  billingInterval?: InputMaybe<SubscriptionInterval>;
  plan?: InputMaybe<Scalars['String']>;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeReactivateSubscriptionArgs = {
  subscriptionId: Scalars['UUID4'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeRedeemSandboxInvitationArgs = {
  invitationToken: Scalars['String'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeRedeemTeamInviteTokenArgs = {
  inviteToken: Scalars['String'];
};


export type RootMutationTypeRejectTeamInvitationArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeRemoveCollaboratorArgs = {
  sandboxId: Scalars['ID'];
  username: Scalars['String'];
};


export type RootMutationTypeRemoveFromTeamArgs = {
  teamId: Scalars['UUID4'];
  userId: Scalars['UUID4'];
};


export type RootMutationTypeRemoveRequestedGithubPullRequestReviewersArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
  reviewers: Array<Scalars['String']>;
};


export type RootMutationTypeRemoveSandboxesFromAlbumArgs = {
  albumId: Scalars['ID'];
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeRenameCollectionArgs = {
  newPath: Scalars['String'];
  newTeamId?: InputMaybe<Scalars['UUID4']>;
  path: Scalars['String'];
  teamId?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeRenameSandboxArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type RootMutationTypeReplyToGithubPullRequestReviewArgs = {
  body: Scalars['String'];
  commentId: Scalars['Int'];
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
};


export type RootMutationTypeRequestGithubPullRequestReviewersArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
  reviewers: Array<Scalars['String']>;
};


export type RootMutationTypeRequestTeamInvitationArgs = {
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeResolveCommentArgs = {
  commentId: Scalars['UUID4'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeRevokeSandboxInvitationArgs = {
  invitationId: Scalars['UUID4'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeRevokeTeamInvitationArgs = {
  teamId: Scalars['UUID4'];
  userId: Scalars['UUID4'];
};


export type RootMutationTypeSetBranchProtectionArgs = {
  branchId: Scalars['String'];
  protected: Scalars['Boolean'];
};


export type RootMutationTypeSetDefaultTeamMemberAuthorizationArgs = {
  defaultAuthorization: TeamMemberAuthorization;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetLiveSessionDefaultPermissionArgs = {
  permission: LiveSessionPermission;
  vmId: Scalars['ID'];
};


export type RootMutationTypeSetLiveSessionGuestPermissionArgs = {
  permission: LiveSessionPermission;
  userId: Scalars['ID'];
  vmId: Scalars['ID'];
};


export type RootMutationTypeSetPreventSandboxesExportArgs = {
  preventSandboxExport: Scalars['Boolean'];
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeSetPreventSandboxesLeavingWorkspaceArgs = {
  preventSandboxLeaving: Scalars['Boolean'];
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeSetPrimaryWorkspaceArgs = {
  primaryWorkspaceId: Scalars['UUID4'];
};


export type RootMutationTypeSetSandboxesFrozenArgs = {
  isFrozen: Scalars['Boolean'];
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeSetSandboxesPrivacyArgs = {
  privacy?: InputMaybe<Scalars['Int']>;
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeSetTeamAiConsentArgs = {
  privateRepositories: Scalars['Boolean'];
  privateSandboxes: Scalars['Boolean'];
  publicRepositories: Scalars['Boolean'];
  publicSandboxes: Scalars['Boolean'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetTeamDescriptionArgs = {
  description: Scalars['String'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetTeamLimitsArgs = {
  onDemandSpendingLimit?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetTeamMetadataArgs = {
  metadata: TeamMetadataInput;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetTeamMinimumPrivacyArgs = {
  minimumPrivacy: Scalars['Int'];
  teamId: Scalars['UUID4'];
  updateDrafts: Scalars['Boolean'];
};


export type RootMutationTypeSetTeamNameArgs = {
  name: Scalars['String'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSetWorkspaceSandboxSettingsArgs = {
  preventSandboxExport: Scalars['Boolean'];
  preventSandboxLeaving: Scalars['Boolean'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeSoftCancelSubscriptionArgs = {
  subscriptionId: Scalars['UUID4'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeStartLiveSessionArgs = {
  defaultPermission: LiveSessionPermission;
  vmId: Scalars['ID'];
};


export type RootMutationTypeStopLiveSessionArgs = {
  vmId: Scalars['ID'];
};


export type RootMutationTypeUnbookmarkTemplateArgs = {
  teamId?: InputMaybe<Scalars['UUID4']>;
  templateId: Scalars['UUID4'];
};


export type RootMutationTypeUnmakeSandboxesTemplatesArgs = {
  sandboxIds: Array<Scalars['ID']>;
};


export type RootMutationTypeUnresolveCommentArgs = {
  commentId: Scalars['UUID4'];
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeUpdateAlbumArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateCommentArgs = {
  codeReferences?: InputMaybe<Array<CodeReference>>;
  commentId: Scalars['UUID4'];
  content?: InputMaybe<Scalars['String']>;
  imageReferences?: InputMaybe<Array<ImageReference>>;
  sandboxId: Scalars['ID'];
  userReferences?: InputMaybe<Array<UserReference>>;
};


export type RootMutationTypeUpdateCurrentUserArgs = {
  bio?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  socialLinks?: InputMaybe<Array<Scalars['String']>>;
  username: Scalars['String'];
};


export type RootMutationTypeUpdateGithubPullRequestReviewArgs = {
  body: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  pullRequestNumber: Scalars['Int'];
  pullRequestReviewId: Scalars['Int'];
};


export type RootMutationTypeUpdateGithubPullRequestReviewCommentArgs = {
  body: Scalars['String'];
  commentId: Scalars['Int'];
  name: Scalars['String'];
  owner: Scalars['String'];
};


export type RootMutationTypeUpdateNotificationPreferencesArgs = {
  emailCommentMention?: InputMaybe<Scalars['Boolean']>;
  emailCommentReply?: InputMaybe<Scalars['Boolean']>;
  emailMarketing?: InputMaybe<Scalars['Boolean']>;
  emailNewComment?: InputMaybe<Scalars['Boolean']>;
  emailSandboxInvite?: InputMaybe<Scalars['Boolean']>;
  emailTeamInvite?: InputMaybe<Scalars['Boolean']>;
  emailTeamRequest?: InputMaybe<Scalars['Boolean']>;
  inAppPrReviewReceived?: InputMaybe<Scalars['Boolean']>;
  inAppPrReviewRequest?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateNotificationReadStatusArgs = {
  notificationId: Scalars['UUID4'];
  read: Scalars['Boolean'];
};


export type RootMutationTypeUpdateProjectSettingsArgs = {
  aiConsent?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateProjectVmTierArgs = {
  branchId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID4'];
  vmTier: Scalars['Int'];
};


export type RootMutationTypeUpdateSandboxSettingsArgs = {
  aiConsent?: InputMaybe<Scalars['Boolean']>;
  sandboxId: Scalars['ID'];
};


export type RootMutationTypeUpdateSubscriptionArgs = {
  quantity?: InputMaybe<Scalars['Int']>;
  subscriptionId: Scalars['UUID4'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateSubscriptionBillingIntervalArgs = {
  billingInterval: SubscriptionInterval;
  subscriptionId: Scalars['UUID4'];
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateUsageSubscriptionArgs = {
  addons: Array<Scalars['String']>;
  teamId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateUsageSubscriptionPlanArgs = {
  billingInterval?: InputMaybe<SubscriptionInterval>;
  plan?: InputMaybe<Scalars['String']>;
  teamId: Scalars['UUID4'];
};

export type RootQueryType = {
  album?: Maybe<Album>;
  albums: Array<Album>;
  /**
   * Get a single branch by its short ID.
   *
   * Returns a "not found" error if the branch does not exist or is inaccessible by the current user.
   * Anonymous users may use this endpoint for branches that exist on read-only projects (see
   * `mutation importReadOnlyProject`).
   *
   * Branches represent real or potential git branches on a particular team's project. Branch short
   * IDs are short alphanumeric strings that point to a particular repository + team + branch name.
   * Remember that a user may have access to the same branch on multiple teams' projects.
   *
   * To look up a branch by repository + team + branch name, see `query branchByName`.
   *
   * Example (for branch with short ID `abc123`):
   *
   * ```gql
   * query branchById(id: "abc123") {
   *   name
   * }
   * ```
   */
  branchById: Branch;
  /**
   * Get a single branch by its repository, team, and name.
   *
   * Returns a "not found" error if the branch does not exist or is inaccessible by the current user.
   * Anonymous users may use this endpoint for branches that exist on read-only projects (see
   * `mutation importReadOnlyProject`).
   *
   * Branches represent real or potential git branches on a particular team's project. Remember that
   * a user may have access to the same branch on multiple teams' projects.
   *
   * To look up a branch by its short ID, see `query branchById`.
   *
   * Example (for `codesandbox/test-repo` branch `test-branch`):
   *
   * ```gql
   * query branchByName(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo",
   *   branch: "test-branch",
   *   team: "987b6fcd-2a3b-41fe-b1e6-ac33565824b9"
   * )
   * ```
   */
  branchByName: Branch;
  curatedAlbums: Array<Album>;
  /**
   * Check for an active live session
   *
   * Accessible to members of the content's workspace and non-editor guests that have already
   * joined the session. Prospective guests should use the mutation `joinLiveSession` with the
   * session's ID instead.
   */
  getLiveSession?: Maybe<LiveSession>;
  /** Get git repo and related V1 sandboxes */
  git?: Maybe<Git>;
  /**
   * Get repositories owned by a GitHub organization.
   *
   * If either `page` or `perPage` are specified, then a single page of results will be returned.
   * If neither argument is given, then all results will be returned. Note that this still requires
   * paginated requests to the GitHub API, but the server will concatenate the results.
   */
  githubOrganizationRepos?: Maybe<Array<GithubRepo>>;
  /** Get a repository as it appears on GitHub */
  githubRepo?: Maybe<GithubRepo>;
  /** The various limits in place for free and paying users and teams */
  limits: Limits;
  /** Get current user */
  me?: Maybe<CurrentUser>;
  /**
   * Get a single project by its repository and team.
   *
   * Projects are identified by repository-team pairs. For public repositories, there may also be a
   * single project that does not have an associated team. For a list of all projects for a given
   * repository, see `query projectsByRepository`.
   *
   * Example (for `https://github.com/codesandbox/test-repo.git`):
   *
   * ```gql
   * query project(
   *   git_provider: GITHUB,
   *   owner: "codesandbox",
   *   repo: "test-repo",
   *   team: "57ca3ef5-475b-47bf-9530-a686c527e174"
   * ) { id }
   * ```
   */
  project?: Maybe<Project>;
  /**
   * Get all projects for the given repository accessible by the current user. Returns an empty list
   * if no such projects are available, or no version of this project has been imported yet.
   *
   * Projects are identified by repository-team pairs. For public repositories, there may also be a
   * single project that does not have an associated team. This query returns all of the projects
   * accessible by the current user (as many as `[# of user teams] + 1`). For information about
   * a project associated with a specific team, see `query project`.
   *
   * Example (for `https://github.com/codesandbox/test-repo.git`):
   *
   * ```gql
   * query projects(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo"
   * ) { id }
   * ```
   */
  projects: Array<Project>;
  /**
   * Get a list of teams that have interacted with a repository recently
   *
   * This endpoint is intended to be used when a user has access to a repository, but does not
   * belong to any teams where the repository has been imported. It returns a brief list of teams
   * (10) that have interacted with that repository recently, with the intention that the user may
   * wish to request an invitation to one of those teams.
   *
   * **Note**: The teams returned by this endpoint are likely to be relevant for **private**
   * repositories only, and unlikely to be relevant for public repositories.
   *
   * ```gql
   * query recentTeamsByRepository(
   *   provider: GITHUB,
   *   owner: "codesandbox",
   *   name: "test-repo"
   * ) { id }
   * ```
   */
  recentTeamsByRepository: Array<TeamPreview>;
  /**
   * Get a sandbox by its (short) ID
   *
   * Requires the current user have read authorization (or that the sandbox is public). Otherwise
   * returns an error (`"unauthorized"`).
   */
  sandbox?: Maybe<Sandbox>;
  /**
   * Returns a sandbox's team ID if the current user is eligible to join that workspace
   *
   * This query is designed for use in 404 experience where the current user does not have access
   * to the resource but *might* have access if they accept an open invitation to its workspace.
   * Returns null if no such open invitation exists, or an error if no user is authenticated.
   *
   * For a list of all workspaces the user is eligible to join, see `query eligibleWorkspaces`.
   * The ID returned by this query can be used in `mutation joinEligibleWorkspace`.
   */
  sandboxEligibleWorkspace?: Maybe<TeamPreview>;
  /** A team from an invite token */
  teamByToken?: Maybe<TeamPreview>;
};


export type RootQueryTypeAlbumArgs = {
  albumId: Scalars['ID'];
};


export type RootQueryTypeAlbumsArgs = {
  username: Scalars['String'];
};


export type RootQueryTypeBranchByIdArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeBranchByNameArgs = {
  branch: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
  team?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeGetLiveSessionArgs = {
  vmId: Scalars['ID'];
};


export type RootQueryTypeGitArgs = {
  branch: Scalars['String'];
  path: Scalars['String'];
  repo: Scalars['String'];
  username: Scalars['String'];
};


export type RootQueryTypeGithubOrganizationReposArgs = {
  organization: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UserRepoSort>;
};


export type RootQueryTypeGithubRepoArgs = {
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootQueryTypeProjectArgs = {
  gitProvider?: InputMaybe<GitProvider>;
  owner: Scalars['String'];
  repo: Scalars['String'];
  team?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeProjectsArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
};


export type RootQueryTypeRecentTeamsByRepositoryArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: GitProvider;
};


export type RootQueryTypeSandboxArgs = {
  sandboxId: Scalars['ID'];
};


export type RootQueryTypeSandboxEligibleWorkspaceArgs = {
  sandboxId: Scalars['ID'];
};


export type RootQueryTypeTeamByTokenArgs = {
  inviteToken: Scalars['String'];
};

export type RootSubscriptionType = {
  /** Receive updates for events related to the specified branch. */
  branchEvents: BranchEvent;
  collaboratorAdded: Collaborator;
  collaboratorChanged: Collaborator;
  collaboratorRemoved: Collaborator;
  commentAdded: Comment;
  commentChanged: Comment;
  commentRemoved: Comment;
  /**
   * Receive updates when the GitHub App sends events via webhook.
   *
   * Note that this subscription will only work for repositories with the GitHub App installed,
   * except for the App installation event itself.
   */
  githubEvents: RepositoryEvent;
  invitationChanged: Invitation;
  invitationCreated: Invitation;
  invitationRemoved: Invitation;
  /**
   * Subscription for changes to the state of a live session
   *
   * Clients may subscribe to this channel in order to be notified when live sessions begin (if
   * they are editors of the underlying content), end, or when permissions are updated.
   */
  liveSessionEvents: LiveSessionEvent;
  /**
   * Receive updates if a new commit is made via the CodeSandbox UI
   *
   * Omit `branchId` to receive updates from all branches in the project.
   */
  projectCommits: BranchLastCommit;
  /**
   * Receive updates if users connect to or disconnect from a branch
   *
   * Omit `branchId` to receive updates from all branches in the project.
   */
  projectConnections: BranchConnections;
  /** Receive updates for events related to the specified repository */
  projectEvents: ProjectEvent;
  /**
   * Receive updates when the status of a branch changes
   *
   * Omit `branchId` to receive updates from all branches in the project.
   */
  projectStatus: BranchStatus;
  sandboxChanged: Sandbox;
  /**
   * Receive updates for events related to one or all of the user's teams
   *
   * Supply a `teamId` to subscribe to one team, or leave the argument `null` to receive events
   * for all of the user's teams.
   */
  teamEvents: TeamEvent;
};


export type RootSubscriptionTypeBranchEventsArgs = {
  branchName: Scalars['String'];
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeCollaboratorAddedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeCollaboratorChangedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeCollaboratorRemovedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentAddedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentChangedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentRemovedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeGithubEventsArgs = {
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeInvitationChangedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeInvitationCreatedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeInvitationRemovedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeLiveSessionEventsArgs = {
  vmId: Scalars['ID'];
};


export type RootSubscriptionTypeProjectCommitsArgs = {
  branchId?: InputMaybe<Scalars['String']>;
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeProjectConnectionsArgs = {
  branchId?: InputMaybe<Scalars['String']>;
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeProjectEventsArgs = {
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeProjectStatusArgs = {
  branchId?: InputMaybe<Scalars['String']>;
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type RootSubscriptionTypeSandboxChangedArgs = {
  sandboxId: Scalars['ID'];
};


export type RootSubscriptionTypeTeamEventsArgs = {
  teamId?: InputMaybe<Scalars['ID']>;
};

/** A Sandbox */
export type Sandbox = {
  alias?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  alwaysOn?: Maybe<Scalars['Boolean']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['UUID4']>;
  authorization: Authorization;
  /** If the sandbox has created a PR, this will refer to the git that you will merge into */
  baseGit?: Maybe<Git>;
  collaborators: Array<Collaborator>;
  collection?: Maybe<Collection>;
  comment?: Maybe<Comment>;
  comments: Array<Comment>;
  /** If the sandbox is a template this will be set */
  customTemplate?: Maybe<Template>;
  description?: Maybe<Scalars['String']>;
  draft: Scalars['Boolean'];
  forkCount: Scalars['Int'];
  forkedTemplate?: Maybe<Template>;
  /** If the sandbox has a v1 git repo tied to it this will be set */
  git?: Maybe<Git>;
  id: Scalars['ID'];
  insertedAt: Scalars['String'];
  invitations: Array<Invitation>;
  isFrozen: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isSse?: Maybe<Scalars['Boolean']>;
  isV2: Scalars['Boolean'];
  /** Depending on the context, this may be the last access of the current user or the aggregate last access for all users */
  lastAccessedAt: Scalars['DateTime'];
  likeCount: Scalars['Int'];
  /** If the sandbox has been made into a git sandbox, then this will be set */
  originalGit?: Maybe<Git>;
  permissions?: Maybe<SandboxProtectionSettings>;
  /** If a PR has been opened on the sandbox, this will be set to the PR number */
  prNumber?: Maybe<Scalars['Int']>;
  privacy: Scalars['Int'];
  removedAt?: Maybe<Scalars['String']>;
  restricted: Scalars['Boolean'];
  screenshotOutdated: Scalars['Boolean'];
  screenshotUrl?: Maybe<Scalars['String']>;
  settings: SandboxSettings;
  source: Source;
  team?: Maybe<TeamPreview>;
  teamId?: Maybe<Scalars['UUID4']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  viewCount: Scalars['Int'];
};


/** A Sandbox */
export type SandboxCommentArgs = {
  commentId: Scalars['UUID4'];
};

export type SandboxProtectionSettings = {
  preventSandboxExport: Scalars['Boolean'];
  preventSandboxLeaving: Scalars['Boolean'];
};

/** User-editable settings for a sandbox */
export type SandboxSettings = {
  /** Whether AI features are explicitly enabled or disabled for this sandbox. If `null`, the team-wide setting applies. */
  aiConsent?: Maybe<Scalars['Boolean']>;
};

export type Source = {
  id?: Maybe<Scalars['UUID4']>;
  template?: Maybe<Scalars['String']>;
};

/** Information about the underlying git status of a branch */
export type Status = {
  hasChanges: Scalars['Boolean'];
  hasConflicts: Scalars['Boolean'];
  remote: StatusCommitCounts;
  target: StatusCommitCounts;
};

/** Counts of how many commits ahead and behind a branch is */
export type StatusCommitCounts = {
  ahead: Scalars['Int'];
  behind: Scalars['Int'];
};

export enum SubscriptionInterval {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type SubscriptionItem = {
  name: Scalars['String'];
  /** Quantity is null for metered items, such as the on-demand credit usage. */
  quantity?: Maybe<Scalars['Int']>;
  unitAmount?: Maybe<Scalars['Int']>;
  unitAmountDecimal?: Maybe<Scalars['String']>;
};

export enum SubscriptionOrigin {
  Legacy = 'LEGACY',
  Patron = 'PATRON',
  Pilot = 'PILOT'
}

export enum SubscriptionPaymentProvider {
  Stripe = 'STRIPE'
}

export type SubscriptionSchedule = {
  billingInterval?: Maybe<SubscriptionInterval>;
  current?: Maybe<SubscriptionSchedulePhase>;
  upcoming?: Maybe<SubscriptionSchedulePhase>;
};

export type SubscriptionSchedulePhase = {
  endDate?: Maybe<Scalars['String']>;
  items: Array<SubscriptionItem>;
  startDate?: Maybe<Scalars['String']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unknown = 'UNKNOWN',
  Unpaid = 'UNPAID'
}

export enum SubscriptionType {
  PersonalPro = 'PERSONAL_PRO',
  TeamPro = 'TEAM_PRO'
}

export enum SubscriptionUpdateMoment {
  Immediately = 'IMMEDIATELY',
  NextBillDate = 'NEXT_BILL_DATE'
}

export type Team = {
  avatarUrl?: Maybe<Scalars['String']>;
  bookmarkedTemplates: Array<Template>;
  collections: Array<Collection>;
  creatorId?: Maybe<Scalars['UUID4']>;
  description?: Maybe<Scalars['String']>;
  /** Draft sandboxes - always returns the current user's drafts */
  drafts: Array<Sandbox>;
  /** Workspace-based feature flags and whether or not they are active for the current workspace */
  featureFlags: TeamFeatureFlags;
  /**
   * Whether the team has reached their limit for on-demand credit purchase
   *
   * This indicator is generally updated at most every 30 minutes, and therefore may be delayed
   * from the moment a team exceeds their usage. Clients are encouraged to warn users about usage
   * approaching their limit using information from the usage, limits, and subscription fields.
   */
  frozen: Scalars['Boolean'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['String'];
  inviteToken: Scalars['String'];
  invitees: Array<User>;
  /** @deprecated There's no such thing as a pilot team anymore */
  joinedPilotAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated No more legacy teams */
  legacy: Scalars['Boolean'];
  limits: TeamLimits;
  members: Array<TeamMember>;
  /** Additional user-provided metadata about the workspace */
  metadata: TeamMetadata;
  name: Scalars['String'];
  privateRegistry?: Maybe<PrivateRegistry>;
  /**
   * Projects assigned to the team
   *
   * By default, repository and permission data older than a certain TTL will be synced from the
   * GitHub API. Using `syncData: false`, clients can request a faster but possibly incorrect
   * response. The incorrect response will be "safe", defaulting to "no" or "read-only" access
   * when a definitive answer isn't available.
   *
   * Projects are returned in the order of the most recent recorded commit on the related
   * repository. Manual ordering by `lastAccessedAt` may be desired.
   */
  projects: Array<Project>;
  sandboxes: Array<Sandbox>;
  settings?: Maybe<WorkspaceSandboxSettings>;
  shortid: Scalars['String'];
  subscription?: Maybe<ProSubscription>;
  subscriptionSchedule?: Maybe<SubscriptionSchedule>;
  templates: Array<Template>;
  /** @deprecated All teams are teams now */
  type: TeamType;
  usage: TeamUsage;
  userAuthorizations: Array<UserAuthorization>;
  users: Array<User>;
};


export type TeamDraftsArgs = {
  authorId?: InputMaybe<Scalars['UUID4']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};


export type TeamProjectsArgs = {
  syncData?: InputMaybe<Scalars['Boolean']>;
};


export type TeamSandboxesArgs = {
  alwaysOn?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['UUID4']>;
  hasOriginalGit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type TeamSubscriptionArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']>;
};

export type TeamAiConsent = {
  privateRepositories: Scalars['Boolean'];
  privateSandboxes: Scalars['Boolean'];
  publicRepositories: Scalars['Boolean'];
  publicSandboxes: Scalars['Boolean'];
};

/** Events related to a team */
export type TeamEvent = TeamSubscriptionEvent;

export type TeamFeatureFlags = {
  friendOfCsb: Scalars['Boolean'];
  ubbBeta: Scalars['Boolean'];
};

export type TeamLimits = {
  /** VM credits included with the team's subscription every month, including add-ons */
  includedCredits: Scalars['Int'];
  /**
   * Number of drafts each team member is allowed to have.
   * Currently this is 10 for free users, and 'unlimited' (aka 10_000) for PRO users.
   */
  includedDrafts: Scalars['Int'];
  /** Number of workspace members included with the team's subscription, including add-ons */
  includedMembers: Scalars['Int'];
  /** Number of included private browser sandboxes with the team's subscription */
  includedPrivateSandboxes: Scalars['Int'];
  /** Number of included public browser sandboxes with the team's subscription */
  includedPublicSandboxes: Scalars['Int'];
  /** DEPRECATED: Number of sandboxes included with the team's subscription */
  includedSandboxes: Scalars['Int'];
  /** Storage (in GB) included with the team's subscription, including add-ons */
  includedStorage: Scalars['Int'];
  /** The maximum VM tier this team can use */
  includedVmTier: Scalars['Int'];
  /** @deprecated Will be removed in a future release */
  maxEditors?: Maybe<Scalars['Int']>;
  /** @deprecated Will be removed in a future release */
  maxPrivateProjects?: Maybe<Scalars['Int']>;
  /** @deprecated Will be removed in a future release */
  maxPrivateSandboxes?: Maybe<Scalars['Int']>;
  /** @deprecated Will be removed in a future release */
  maxPublicProjects?: Maybe<Scalars['Int']>;
  /** @deprecated Will be removed in a future release */
  maxPublicSandboxes?: Maybe<Scalars['Int']>;
  /**
   * Maximum number of credits that can be purchased on-demand in a month
   *
   * This value is set automatically based on the `onDemandSpendingLimit` set by the user using
   * `mutation setTeamLimits`.
   */
  onDemandCreditLimit?: Maybe<Scalars['Int']>;
  /**
   * Maximum spending, in whole dollars, allowed for on-demand credits in a month
   *
   * This value is set by the user using `mutation setTeamLimits`.
   */
  onDemandSpendingLimit?: Maybe<Scalars['Int']>;
};

export type TeamMember = {
  avatarUrl: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  githubUsername?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export enum TeamMemberAuthorization {
  /** Permission to add/remove users and change permissions (in addition to write and read). */
  Admin = 'ADMIN',
  /** Permission view and comment on team sandboxes. */
  Read = 'READ',
  /** Permission create and edit team sandboxes (in addition to read). */
  Write = 'WRITE'
}

/** Additional user-provided metadata about a workspace */
export type TeamMetadata = {
  /** Use-cases for the workspace provided during creation */
  useCases: Array<Scalars['String']>;
};

/** Additional user-provided metadata about a workspace */
export type TeamMetadataInput = {
  /** Use-cases for the workspace */
  useCases: Array<Scalars['String']>;
};

export type TeamPreview = {
  avatarUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  shortid: Scalars['String'];
};

/** Change to a team's subscription status */
export type TeamSubscriptionEvent = {
  event: Scalars['String'];
  subscription: ProSubscription;
  teamId: Scalars['ID'];
};

export enum TeamType {
  Personal = 'PERSONAL',
  Team = 'TEAM'
}

export type TeamUsage = {
  credits: Scalars['Int'];
  editorsQuantity: Scalars['Int'];
  privateProjectsQuantity: Scalars['Int'];
  privateSandboxesQuantity: Scalars['Int'];
  publicProjectsQuantity: Scalars['Int'];
  publicSandboxesQuantity: Scalars['Int'];
  restrictedSandboxes: Scalars['Int'];
  sandboxes: Scalars['Int'];
  unrestrictedSandboxes: Scalars['Int'];
};

/** A Template */
export type Template = {
  bookmarked?: Maybe<Array<Maybe<Bookmarked>>>;
  color?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated and will always be null. Query sandbox > description instead */
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  insertedAt?: Maybe<Scalars['String']>;
  official: Scalars['Boolean'];
  published?: Maybe<Scalars['Boolean']>;
  sandbox?: Maybe<Sandbox>;
  /** @deprecated This field is deprecated and will always be null. Query sandbox > title instead */
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** A CodeSandbox User */
export type User = {
  avatarUrl: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name?: Maybe<Scalars['String']>;
  personalWorkspaceId: Scalars['UUID4'];
  socialLinks?: Maybe<Array<Scalars['String']>>;
  username: Scalars['String'];
};

export type UserAuthorization = {
  authorization: TeamMemberAuthorization;
  drafts: Scalars['Int'];
  teamManager: Scalars['Boolean'];
  userId: Scalars['UUID4'];
};

export type UserFeatureFlags = {
  ubbBeta: Scalars['Boolean'];
};

export type UserReference = {
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type UserReferenceMetadata = {
  userId: Scalars['String'];
  username: Scalars['String'];
};

/** The relationship between a user and a repository they have access to */
export enum UserRepoAffiliation {
  Collaborator = 'COLLABORATOR',
  OrganizationMember = 'ORGANIZATION_MEMBER',
  Owner = 'OWNER'
}

/** Sorting key for repositories */
export enum UserRepoSort {
  Created = 'CREATED',
  FullName = 'FULL_NAME',
  Pushed = 'PUSHED',
  Updated = 'UPDATED'
}

export type WorkspaceSandboxSettings = {
  aiConsent: TeamAiConsent;
  defaultAuthorization: TeamMemberAuthorization;
  minimumPrivacy: Scalars['Int'];
  preventSandboxExport: Scalars['Boolean'];
  preventSandboxLeaving: Scalars['Boolean'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Album: ResolverTypeWrapper<Album>;
  AuthType: AuthType;
  Authorization: Authorization;
  Base64: ResolverTypeWrapper<Scalars['Base64']>;
  BillingDetails: ResolverTypeWrapper<BillingDetails>;
  BillingPreview: ResolverTypeWrapper<BillingPreview>;
  BookmarkEntity: ResolversTypes['Team'] | ResolversTypes['User'];
  Bookmarked: ResolverTypeWrapper<Omit<Bookmarked, 'entity'> & { entity?: Maybe<ResolversTypes['BookmarkEntity']> }>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Branch: ResolverTypeWrapper<Branch>;
  BranchConnections: ResolverTypeWrapper<BranchConnections>;
  BranchEvent: ResolversTypes['PullRequestCommentEvent'] | ResolversTypes['PullRequestEvent'] | ResolversTypes['PullRequestReviewCommentEvent'] | ResolversTypes['PullRequestReviewEvent'];
  BranchLastCommit: ResolverTypeWrapper<BranchLastCommit>;
  BranchSettings: ResolverTypeWrapper<BranchSettings>;
  BranchStatus: ResolverTypeWrapper<BranchStatus>;
  CodeReference: CodeReference;
  CodeReferenceMetadata: ResolverTypeWrapper<CodeReferenceMetadata>;
  Collaborator: ResolverTypeWrapper<Collaborator>;
  Collection: ResolverTypeWrapper<Collection>;
  Comment: ResolverTypeWrapper<Comment>;
  Connection: ResolverTypeWrapper<Connection>;
  CurrentUser: ResolverTypeWrapper<CurrentUser>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  Direction: Direction;
  Git: ResolverTypeWrapper<Git>;
  GitHubAuthorAssociation: GitHubAuthorAssociation;
  GitHubPullRequestComment: ResolverTypeWrapper<GitHubPullRequestComment>;
  GitHubPullRequestMergeMethod: GitHubPullRequestMergeMethod;
  GitHubPullRequestReviewAction: GitHubPullRequestReviewAction;
  GitHubPullRequestReviewComment: ResolverTypeWrapper<GitHubPullRequestReviewComment>;
  GitHubPullRequestReviewCommentSide: GitHubPullRequestReviewCommentSide;
  GitHubPullRequestReviewCommentSubjectType: GitHubPullRequestReviewCommentSubjectType;
  GitHubRepository: ResolverTypeWrapper<GitHubRepository>;
  GitProvider: GitProvider;
  GithubOrganization: ResolverTypeWrapper<GithubOrganization>;
  GithubPermission: GithubPermission;
  GithubProfile: ResolverTypeWrapper<GithubProfile>;
  GithubPullRequestReviewCommentInput: GithubPullRequestReviewCommentInput;
  GithubRepo: ResolverTypeWrapper<GithubRepo>;
  GithubRepoAuthorization: GithubRepoAuthorization;
  GithubRequestedReviewer: ResolverTypeWrapper<GithubRequestedReviewer>;
  GithubRequestedTeam: ResolverTypeWrapper<GithubRequestedTeam>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  ImageReference: ImageReference;
  ImageReferenceMetadata: ResolverTypeWrapper<ImageReferenceMetadata>;
  InstallationEvent: ResolverTypeWrapper<InstallationEvent>;
  InstallationEventAction: InstallationEventAction;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Invitation: ResolverTypeWrapper<Invitation>;
  InvoicePreview: ResolverTypeWrapper<InvoicePreview>;
  LastCommit: ResolverTypeWrapper<LastCommit>;
  Limits: ResolverTypeWrapper<Limits>;
  LiveSession: ResolverTypeWrapper<LiveSession>;
  LiveSessionEvent: ResolverTypeWrapper<LiveSessionEvent>;
  LiveSessionEventAction: LiveSessionEventAction;
  LiveSessionGuest: ResolverTypeWrapper<LiveSessionGuest>;
  LiveSessionHost: ResolverTypeWrapper<LiveSessionHost>;
  LiveSessionPermission: LiveSessionPermission;
  MemberAuthorization: MemberAuthorization;
  NaiveDateTime: ResolverTypeWrapper<Scalars['NaiveDateTime']>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationPreferences: ResolverTypeWrapper<NotificationPreferences>;
  OrderBy: OrderBy;
  PreviewReference: PreviewReference;
  PreviewReferenceMetadata: ResolverTypeWrapper<PreviewReferenceMetadata>;
  PrivateRegistry: ResolverTypeWrapper<PrivateRegistry>;
  ProSubscription: ResolverTypeWrapper<ProSubscription>;
  Project: ResolverTypeWrapper<Omit<Project, 'repository'> & { repository: ResolversTypes['Repository'] }>;
  ProjectAuthorization: ProjectAuthorization;
  ProjectEvent: ResolversTypes['PullRequestCommentEvent'] | ResolversTypes['PullRequestEvent'] | ResolversTypes['PullRequestReviewCommentEvent'] | ResolversTypes['PullRequestReviewEvent'];
  ProjectSettings: ResolverTypeWrapper<ProjectSettings>;
  ProviderName: ProviderName;
  PullRequest: ResolverTypeWrapper<Omit<PullRequest, 'baseRepository'> & { baseRepository: ResolversTypes['Repository'] }>;
  PullRequestCommentEvent: ResolverTypeWrapper<PullRequestCommentEvent>;
  PullRequestCommentEventAction: PullRequestCommentEventAction;
  PullRequestEvent: ResolverTypeWrapper<PullRequestEvent>;
  PullRequestEventAction: PullRequestEventAction;
  PullRequestReview: ResolverTypeWrapper<PullRequestReview>;
  PullRequestReviewCommentEvent: ResolverTypeWrapper<PullRequestReviewCommentEvent>;
  PullRequestReviewCommentEventAction: PullRequestReviewCommentEventAction;
  PullRequestReviewEvent: ResolverTypeWrapper<PullRequestReviewEvent>;
  PullRequestReviewEventAction: PullRequestReviewEventAction;
  PullRequestReviewState: PullRequestReviewState;
  Reference: ResolverTypeWrapper<Omit<Reference, 'metadata'> & { metadata: ResolversTypes['ReferenceMetadata'] }>;
  ReferenceMetadata: ResolversTypes['CodeReferenceMetadata'] | ResolversTypes['ImageReferenceMetadata'] | ResolversTypes['PreviewReferenceMetadata'] | ResolversTypes['UserReferenceMetadata'];
  RegistryType: RegistryType;
  Repository: ResolversTypes['GitHubRepository'];
  RepositoryEvent: ResolversTypes['InstallationEvent'];
  Resources: ResolverTypeWrapper<Resources>;
  RootMutationType: ResolverTypeWrapper<{}>;
  RootQueryType: ResolverTypeWrapper<{}>;
  RootSubscriptionType: ResolverTypeWrapper<{}>;
  Sandbox: ResolverTypeWrapper<Sandbox>;
  SandboxProtectionSettings: ResolverTypeWrapper<SandboxProtectionSettings>;
  SandboxSettings: ResolverTypeWrapper<SandboxSettings>;
  Source: ResolverTypeWrapper<Source>;
  Status: ResolverTypeWrapper<Status>;
  StatusCommitCounts: ResolverTypeWrapper<StatusCommitCounts>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SubscriptionInterval: SubscriptionInterval;
  SubscriptionItem: ResolverTypeWrapper<SubscriptionItem>;
  SubscriptionOrigin: SubscriptionOrigin;
  SubscriptionPaymentProvider: SubscriptionPaymentProvider;
  SubscriptionSchedule: ResolverTypeWrapper<SubscriptionSchedule>;
  SubscriptionSchedulePhase: ResolverTypeWrapper<SubscriptionSchedulePhase>;
  SubscriptionStatus: SubscriptionStatus;
  SubscriptionType: SubscriptionType;
  SubscriptionUpdateMoment: SubscriptionUpdateMoment;
  Team: ResolverTypeWrapper<Team>;
  TeamAiConsent: ResolverTypeWrapper<TeamAiConsent>;
  TeamEvent: ResolversTypes['TeamSubscriptionEvent'];
  TeamFeatureFlags: ResolverTypeWrapper<TeamFeatureFlags>;
  TeamLimits: ResolverTypeWrapper<TeamLimits>;
  TeamMember: ResolverTypeWrapper<TeamMember>;
  TeamMemberAuthorization: TeamMemberAuthorization;
  TeamMetadata: ResolverTypeWrapper<TeamMetadata>;
  TeamMetadataInput: TeamMetadataInput;
  TeamPreview: ResolverTypeWrapper<TeamPreview>;
  TeamSubscriptionEvent: ResolverTypeWrapper<TeamSubscriptionEvent>;
  TeamType: TeamType;
  TeamUsage: ResolverTypeWrapper<TeamUsage>;
  Template: ResolverTypeWrapper<Template>;
  UUID4: ResolverTypeWrapper<Scalars['UUID4']>;
  User: ResolverTypeWrapper<User>;
  UserAuthorization: ResolverTypeWrapper<UserAuthorization>;
  UserFeatureFlags: ResolverTypeWrapper<UserFeatureFlags>;
  UserReference: UserReference;
  UserReferenceMetadata: ResolverTypeWrapper<UserReferenceMetadata>;
  UserRepoAffiliation: UserRepoAffiliation;
  UserRepoSort: UserRepoSort;
  WorkspaceSandboxSettings: ResolverTypeWrapper<WorkspaceSandboxSettings>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Album: Album;
  Base64: Scalars['Base64'];
  BillingDetails: BillingDetails;
  BillingPreview: BillingPreview;
  BookmarkEntity: ResolversParentTypes['Team'] | ResolversParentTypes['User'];
  Bookmarked: Omit<Bookmarked, 'entity'> & { entity?: Maybe<ResolversParentTypes['BookmarkEntity']> };
  Boolean: Scalars['Boolean'];
  Branch: Branch;
  BranchConnections: BranchConnections;
  BranchEvent: ResolversParentTypes['PullRequestCommentEvent'] | ResolversParentTypes['PullRequestEvent'] | ResolversParentTypes['PullRequestReviewCommentEvent'] | ResolversParentTypes['PullRequestReviewEvent'];
  BranchLastCommit: BranchLastCommit;
  BranchSettings: BranchSettings;
  BranchStatus: BranchStatus;
  CodeReference: CodeReference;
  CodeReferenceMetadata: CodeReferenceMetadata;
  Collaborator: Collaborator;
  Collection: Collection;
  Comment: Comment;
  Connection: Connection;
  CurrentUser: CurrentUser;
  DateTime: Scalars['DateTime'];
  Git: Git;
  GitHubPullRequestComment: GitHubPullRequestComment;
  GitHubPullRequestReviewComment: GitHubPullRequestReviewComment;
  GitHubRepository: GitHubRepository;
  GithubOrganization: GithubOrganization;
  GithubProfile: GithubProfile;
  GithubPullRequestReviewCommentInput: GithubPullRequestReviewCommentInput;
  GithubRepo: GithubRepo;
  GithubRequestedReviewer: GithubRequestedReviewer;
  GithubRequestedTeam: GithubRequestedTeam;
  ID: Scalars['ID'];
  ImageReference: ImageReference;
  ImageReferenceMetadata: ImageReferenceMetadata;
  InstallationEvent: InstallationEvent;
  Int: Scalars['Int'];
  Invitation: Invitation;
  InvoicePreview: InvoicePreview;
  LastCommit: LastCommit;
  Limits: Limits;
  LiveSession: LiveSession;
  LiveSessionEvent: LiveSessionEvent;
  LiveSessionGuest: LiveSessionGuest;
  LiveSessionHost: LiveSessionHost;
  MemberAuthorization: MemberAuthorization;
  NaiveDateTime: Scalars['NaiveDateTime'];
  Notification: Notification;
  NotificationPreferences: NotificationPreferences;
  OrderBy: OrderBy;
  PreviewReference: PreviewReference;
  PreviewReferenceMetadata: PreviewReferenceMetadata;
  PrivateRegistry: PrivateRegistry;
  ProSubscription: ProSubscription;
  Project: Omit<Project, 'repository'> & { repository: ResolversParentTypes['Repository'] };
  ProjectEvent: ResolversParentTypes['PullRequestCommentEvent'] | ResolversParentTypes['PullRequestEvent'] | ResolversParentTypes['PullRequestReviewCommentEvent'] | ResolversParentTypes['PullRequestReviewEvent'];
  ProjectSettings: ProjectSettings;
  PullRequest: Omit<PullRequest, 'baseRepository'> & { baseRepository: ResolversParentTypes['Repository'] };
  PullRequestCommentEvent: PullRequestCommentEvent;
  PullRequestEvent: PullRequestEvent;
  PullRequestReview: PullRequestReview;
  PullRequestReviewCommentEvent: PullRequestReviewCommentEvent;
  PullRequestReviewEvent: PullRequestReviewEvent;
  Reference: Omit<Reference, 'metadata'> & { metadata: ResolversParentTypes['ReferenceMetadata'] };
  ReferenceMetadata: ResolversParentTypes['CodeReferenceMetadata'] | ResolversParentTypes['ImageReferenceMetadata'] | ResolversParentTypes['PreviewReferenceMetadata'] | ResolversParentTypes['UserReferenceMetadata'];
  Repository: ResolversParentTypes['GitHubRepository'];
  RepositoryEvent: ResolversParentTypes['InstallationEvent'];
  Resources: Resources;
  RootMutationType: {};
  RootQueryType: {};
  RootSubscriptionType: {};
  Sandbox: Sandbox;
  SandboxProtectionSettings: SandboxProtectionSettings;
  SandboxSettings: SandboxSettings;
  Source: Source;
  Status: Status;
  StatusCommitCounts: StatusCommitCounts;
  String: Scalars['String'];
  SubscriptionItem: SubscriptionItem;
  SubscriptionSchedule: SubscriptionSchedule;
  SubscriptionSchedulePhase: SubscriptionSchedulePhase;
  Team: Team;
  TeamAiConsent: TeamAiConsent;
  TeamEvent: ResolversParentTypes['TeamSubscriptionEvent'];
  TeamFeatureFlags: TeamFeatureFlags;
  TeamLimits: TeamLimits;
  TeamMember: TeamMember;
  TeamMetadata: TeamMetadata;
  TeamMetadataInput: TeamMetadataInput;
  TeamPreview: TeamPreview;
  TeamSubscriptionEvent: TeamSubscriptionEvent;
  TeamUsage: TeamUsage;
  Template: Template;
  UUID4: Scalars['UUID4'];
  User: User;
  UserAuthorization: UserAuthorization;
  UserFeatureFlags: UserFeatureFlags;
  UserReference: UserReference;
  UserReferenceMetadata: UserReferenceMetadata;
  WorkspaceSandboxSettings: WorkspaceSandboxSettings;
};

export type AlbumResolvers<ContextType = any, ParentType extends ResolversParentTypes['Album'] = ResolversParentTypes['Album']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Base64ScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Base64'], any> {
  name: 'Base64';
}

export type BillingDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingDetails'] = ResolversParentTypes['BillingDetails']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingPreview'] = ResolversParentTypes['BillingPreview']> = {
  immediatePayment?: Resolver<Maybe<ResolversTypes['BillingDetails']>, ParentType, ContextType>;
  nextPayment?: Resolver<Maybe<ResolversTypes['BillingDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookmarkEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookmarkEntity'] = ResolversParentTypes['BookmarkEntity']> = {
  __resolveType: TypeResolveFn<'Team' | 'User', ParentType, ContextType>;
};

export type BookmarkedResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bookmarked'] = ResolversParentTypes['Bookmarked']> = {
  entity?: Resolver<Maybe<ResolversTypes['BookmarkEntity']>, ParentType, ContextType>;
  isBookmarked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['Branch'] = ResolversParentTypes['Branch']> = {
  aiConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connections?: Resolver<Array<ResolversTypes['Connection']>, ParentType, ContextType>;
  contribution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  contributionOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastAccessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCommit?: Resolver<Maybe<ResolversTypes['LastCommit']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  pullRequests?: Resolver<Array<ResolversTypes['PullRequest']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['BranchSettings'], ParentType, ContextType>;
  sourceBranch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Status']>, ParentType, ContextType>;
  upstream?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchConnectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchConnections'] = ResolversParentTypes['BranchConnections']> = {
  branchId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connections?: Resolver<Array<ResolversTypes['Connection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchEvent'] = ResolversParentTypes['BranchEvent']> = {
  __resolveType: TypeResolveFn<'PullRequestCommentEvent' | 'PullRequestEvent' | 'PullRequestReviewCommentEvent' | 'PullRequestReviewEvent', ParentType, ContextType>;
};

export type BranchLastCommitResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchLastCommit'] = ResolversParentTypes['BranchLastCommit']> = {
  branchId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastCommit?: Resolver<ResolversTypes['LastCommit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchSettings'] = ResolversParentTypes['BranchSettings']> = {
  protected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchStatus'] = ResolversParentTypes['BranchStatus']> = {
  branchId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Status'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeReferenceMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeReferenceMetadata'] = ResolversParentTypes['CodeReferenceMetadata']> = {
  anchor?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  head?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sandboxId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollaboratorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collaborator'] = ResolversParentTypes['Collaborator']> = {
  authorization?: Resolver<ResolversTypes['Authorization'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sandbox?: Resolver<ResolversTypes['Sandbox'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collection'] = ResolversParentTypes['Collection']> = {
  id?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sandboxCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  teamId?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment']> = {
  anchorReference?: Resolver<Maybe<ResolversTypes['Reference']>, ParentType, ContextType>;
  comments?: Resolver<Array<ResolversTypes['Comment']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['NaiveDateTime'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isResolved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parentComment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType>;
  references?: Resolver<Array<ResolversTypes['Reference']>, ParentType, ContextType>;
  replyCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sandbox?: Resolver<ResolversTypes['Sandbox'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['NaiveDateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUser'] = ResolversParentTypes['CurrentUser']> = {
  bookmarkedTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType>;
  collaboratorSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['Collection']>, ParentType, ContextType, RequireFields<CurrentUserCollectionArgs, 'path'>>;
  collections?: Resolver<Array<ResolversTypes['Collection']>, ParentType, ContextType, Partial<CurrentUserCollectionsArgs>>;
  deletionRequested?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eligibleForTrial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eligibleWorkspaces?: Resolver<Array<ResolversTypes['TeamPreview']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  featureFlags?: Resolver<ResolversTypes['UserFeatureFlags'], ParentType, ContextType>;
  githubOrganizations?: Resolver<Maybe<Array<ResolversTypes['GithubOrganization']>>, ParentType, ContextType>;
  githubProfile?: Resolver<Maybe<ResolversTypes['GithubProfile']>, ParentType, ContextType>;
  githubRepos?: Resolver<Array<ResolversTypes['GithubRepo']>, ParentType, ContextType, RequireFields<CurrentUserGithubReposArgs, 'affiliation' | 'sort'>>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  likedSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationPreferences?: Resolver<Maybe<ResolversTypes['NotificationPreferences']>, ParentType, ContextType>;
  notifications?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType, Partial<CurrentUserNotificationsArgs>>;
  personalWorkspaceId?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  primaryWorkspaceId?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['ProviderName'], ParentType, ContextType>;
  recentBranches?: Resolver<Array<ResolversTypes['Branch']>, ParentType, ContextType, RequireFields<CurrentUserRecentBranchesArgs, 'limit'>>;
  recentProjects?: Resolver<Array<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<CurrentUserRecentProjectsArgs, 'limit'>>;
  recentlyAccessedSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<CurrentUserRecentlyAccessedSandboxesArgs>>;
  recentlyUsedTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, Partial<CurrentUserRecentlyUsedTemplatesArgs>>;
  sandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<CurrentUserSandboxesArgs>>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType, Partial<CurrentUserTeamArgs>>;
  teams?: Resolver<Array<ResolversTypes['Team']>, ParentType, ContextType>;
  templates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, Partial<CurrentUserTemplatesArgs>>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workspaces?: Resolver<Array<ResolversTypes['Team']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type GitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Git'] = ResolversParentTypes['Git']> = {
  baseGitSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<GitBaseGitSandboxesArgs>>;
  branch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commitSha?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  originalGitSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<GitOriginalGitSandboxesArgs>>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  repo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GitHubPullRequestCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['GitHubPullRequestComment'] = ResolversParentTypes['GitHubPullRequestComment']> = {
  authorAssociation?: Resolver<ResolversTypes['GitHubAuthorAssociation'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  htmlUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  issueId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GitHubPullRequestReviewCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['GitHubPullRequestReviewComment'] = ResolversParentTypes['GitHubPullRequestReviewComment']> = {
  authorAssociation?: Resolver<ResolversTypes['GitHubAuthorAssociation'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  diffHunk?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  htmlUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inReplyToId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  line?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalCommitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalLine?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalStartLine?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullRequestReviewId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  side?: Resolver<Maybe<ResolversTypes['GitHubPullRequestReviewCommentSide']>, ParentType, ContextType>;
  startLine?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startSide?: Resolver<Maybe<ResolversTypes['GitHubPullRequestReviewCommentSide']>, ParentType, ContextType>;
  subjectType?: Resolver<Maybe<ResolversTypes['GitHubPullRequestReviewCommentSubjectType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GitHubRepositoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GitHubRepository'] = ResolversParentTypes['GitHubRepository']> = {
  allowForking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  defaultBranch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fork?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['GitHubRepository']>, ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['GithubPermission'], ParentType, ContextType>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pushedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['GitHubRepository']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GithubOrganization'] = ResolversParentTypes['GithubOrganization']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['GithubProfile'] = ResolversParentTypes['GithubProfile']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubRepoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GithubRepo'] = ResolversParentTypes['GithubRepo']> = {
  appInstalled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  authorization?: Resolver<ResolversTypes['GithubRepoAuthorization'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['GithubOrganization'], ParentType, ContextType>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pushedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubRequestedReviewerResolvers<ContextType = any, ParentType extends ResolversParentTypes['GithubRequestedReviewer'] = ResolversParentTypes['GithubRequestedReviewer']> = {
  requestedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubRequestedTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['GithubRequestedTeam'] = ResolversParentTypes['GithubRequestedTeam']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageReferenceMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageReferenceMetadata'] = ResolversParentTypes['ImageReferenceMetadata']> = {
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolution?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallationEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstallationEvent'] = ResolversParentTypes['InstallationEvent']> = {
  action?: Resolver<ResolversTypes['InstallationEventAction'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invitation'] = ResolversParentTypes['Invitation']> = {
  authorization?: Resolver<ResolversTypes['Authorization'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sandbox?: Resolver<ResolversTypes['Sandbox'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoicePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoicePreview'] = ResolversParentTypes['InvoicePreview']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalExcludingTax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateMoment?: Resolver<Maybe<ResolversTypes['SubscriptionUpdateMoment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastCommitResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastCommit'] = ResolversParentTypes['LastCommit']> = {
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sha?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Limits'] = ResolversParentTypes['Limits']> = {
  personalFree?: Resolver<ResolversTypes['TeamLimits'], ParentType, ContextType>;
  personalPro?: Resolver<ResolversTypes['TeamLimits'], ParentType, ContextType>;
  teamFree?: Resolver<ResolversTypes['TeamLimits'], ParentType, ContextType>;
  teamPro?: Resolver<ResolversTypes['TeamLimits'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveSession'] = ResolversParentTypes['LiveSession']> = {
  defaultPermission?: Resolver<ResolversTypes['LiveSessionPermission'], ParentType, ContextType>;
  guests?: Resolver<Array<ResolversTypes['LiveSessionGuest']>, ParentType, ContextType>;
  host?: Resolver<Maybe<ResolversTypes['LiveSessionHost']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stoppedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vmId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveSessionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveSessionEvent'] = ResolversParentTypes['LiveSessionEvent']> = {
  event?: Resolver<ResolversTypes['LiveSessionEventAction'], ParentType, ContextType>;
  session?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveSessionGuestResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveSessionGuest'] = ResolversParentTypes['LiveSessionGuest']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['LiveSessionPermission'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveSessionHostResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveSessionHost'] = ResolversParentTypes['LiveSessionHost']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface NaiveDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['NaiveDateTime'], any> {
  name: 'NaiveDateTime';
}

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['NaiveDateTime'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPreferences'] = ResolversParentTypes['NotificationPreferences']> = {
  emailCommentMention?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailCommentReply?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailMarketing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailNewComment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailSandboxInvite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailTeamInvite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailTeamRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inAppPrReviewReceived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inAppPrReviewRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviewReferenceMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewReferenceMetadata'] = ResolversParentTypes['PreviewReferenceMetadata']> = {
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previewPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  screenshotUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userAgent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  x?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrivateRegistryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrivateRegistry'] = ResolversParentTypes['PrivateRegistry']> = {
  authType?: Resolver<Maybe<ResolversTypes['AuthType']>, ParentType, ContextType>;
  enabledScopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  limitToScopes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  proxyEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  registryAuthKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registryType?: Resolver<ResolversTypes['RegistryType'], ParentType, ContextType>;
  registryUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sandpackTrustedDomains?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  teamId?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProSubscription'] = ResolversParentTypes['ProSubscription']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  billingInterval?: Resolver<Maybe<ResolversTypes['SubscriptionInterval']>, ParentType, ContextType>;
  cancelAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancelAtPeriodEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  nextBillDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['SubscriptionOrigin']>, ParentType, ContextType>;
  paymentMethodAttached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['SubscriptionPaymentProvider']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubscriptionStatus'], ParentType, ContextType>;
  trialEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  trialStart?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SubscriptionType'], ParentType, ContextType>;
  unitPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateBillingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = {
  appInstalled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  authorization?: Resolver<ResolversTypes['ProjectAuthorization'], ParentType, ContextType>;
  branchByName?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType, RequireFields<ProjectBranchByNameArgs, 'name'>>;
  branchCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  branches?: Resolver<Array<ResolversTypes['Branch']>, ParentType, ContextType>;
  connections?: Resolver<Array<ResolversTypes['Connection']>, ParentType, ContextType>;
  defaultBranch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAccessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCommit?: Resolver<Maybe<ResolversTypes['LastCommit']>, ParentType, ContextType>;
  pullRequests?: Resolver<Array<ResolversTypes['PullRequest']>, ParentType, ContextType>;
  repository?: Resolver<ResolversTypes['Repository'], ParentType, ContextType>;
  resources?: Resolver<ResolversTypes['Resources'], ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['ProjectSettings'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectEvent'] = ResolversParentTypes['ProjectEvent']> = {
  __resolveType: TypeResolveFn<'PullRequestCommentEvent' | 'PullRequestEvent' | 'PullRequestReviewCommentEvent' | 'PullRequestReviewEvent', ParentType, ContextType>;
};

export type ProjectSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectSettings'] = ResolversParentTypes['ProjectSettings']> = {
  aiConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequest'] = ResolversParentTypes['PullRequest']> = {
  additions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  baseBranch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseRepository?: Resolver<ResolversTypes['Repository'], ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changedFiles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comments?: Resolver<Array<ResolversTypes['GitHubPullRequestComment']>, ParentType, ContextType>;
  commentsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commitsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  creatorUsername?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  draft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  headBranch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  htmlUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mergeable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mergeableStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prClosedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  prCreatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  prMergedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  prUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requestedReviewers?: Resolver<Array<ResolversTypes['GithubRequestedReviewer']>, ParentType, ContextType>;
  requestedTeams?: Resolver<Array<ResolversTypes['GithubRequestedTeam']>, ParentType, ContextType>;
  reviewCommentsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviews?: Resolver<Array<ResolversTypes['PullRequestReview']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestCommentEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequestCommentEvent'] = ResolversParentTypes['PullRequestCommentEvent']> = {
  action?: Resolver<ResolversTypes['PullRequestCommentEventAction'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['GitHubPullRequestComment'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullRequest?: Resolver<Maybe<ResolversTypes['PullRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequestEvent'] = ResolversParentTypes['PullRequestEvent']> = {
  action?: Resolver<ResolversTypes['PullRequestEventAction'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullRequest?: Resolver<ResolversTypes['PullRequest'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequestReview'] = ResolversParentTypes['PullRequestReview']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Array<ResolversTypes['GitHubPullRequestReviewComment']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['PullRequestReviewState'], ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  syncedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestReviewCommentEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequestReviewCommentEvent'] = ResolversParentTypes['PullRequestReviewCommentEvent']> = {
  action?: Resolver<ResolversTypes['PullRequestReviewCommentEventAction'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['GitHubPullRequestReviewComment'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullRequest?: Resolver<ResolversTypes['PullRequest'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullRequestReviewEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullRequestReviewEvent'] = ResolversParentTypes['PullRequestReviewEvent']> = {
  action?: Resolver<ResolversTypes['PullRequestReviewEventAction'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullRequest?: Resolver<ResolversTypes['PullRequest'], ParentType, ContextType>;
  review?: Resolver<ResolversTypes['PullRequestReview'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reference'] = ResolversParentTypes['Reference']> = {
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['ReferenceMetadata'], ParentType, ContextType>;
  resource?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferenceMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceMetadata'] = ResolversParentTypes['ReferenceMetadata']> = {
  __resolveType: TypeResolveFn<'CodeReferenceMetadata' | 'ImageReferenceMetadata' | 'PreviewReferenceMetadata' | 'UserReferenceMetadata', ParentType, ContextType>;
};

export type RepositoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Repository'] = ResolversParentTypes['Repository']> = {
  __resolveType: TypeResolveFn<'GitHubRepository', ParentType, ContextType>;
};

export type RepositoryEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepositoryEvent'] = ResolversParentTypes['RepositoryEvent']> = {
  __resolveType: TypeResolveFn<'InstallationEvent', ParentType, ContextType>;
};

export type ResourcesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Resources'] = ResolversParentTypes['Resources']> = {
  cpu?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  memory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  storage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RootMutationTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootMutationType'] = ResolversParentTypes['RootMutationType']> = {
  acceptTeamInvitation?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeAcceptTeamInvitationArgs, 'teamId'>>;
  addCollaborator?: Resolver<ResolversTypes['Collaborator'], ParentType, ContextType, RequireFields<RootMutationTypeAddCollaboratorArgs, 'authorization' | 'sandboxId' | 'username'>>;
  addSandboxesToAlbum?: Resolver<Maybe<ResolversTypes['Album']>, ParentType, ContextType, RequireFields<RootMutationTypeAddSandboxesToAlbumArgs, 'albumId' | 'sandboxIds'>>;
  addToCollection?: Resolver<ResolversTypes['Collection'], ParentType, ContextType, RequireFields<RootMutationTypeAddToCollectionArgs, 'collectionPath'>>;
  addToCollectionOrTeam?: Resolver<Array<Maybe<ResolversTypes['Sandbox']>>, ParentType, ContextType, Partial<RootMutationTypeAddToCollectionOrTeamArgs>>;
  archiveAllNotifications?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  archiveNotification?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<RootMutationTypeArchiveNotificationArgs, 'notificationId'>>;
  bookmarkTemplate?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<RootMutationTypeBookmarkTemplateArgs, 'templateId'>>;
  cancelDeleteCurrentUser?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changeCollaboratorAuthorization?: Resolver<ResolversTypes['Collaborator'], ParentType, ContextType, RequireFields<RootMutationTypeChangeCollaboratorAuthorizationArgs, 'authorization' | 'sandboxId' | 'username'>>;
  changeSandboxInvitationAuthorization?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootMutationTypeChangeSandboxInvitationAuthorizationArgs, 'authorization' | 'invitationId' | 'sandboxId'>>;
  changeTeamMemberAuthorizations?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeChangeTeamMemberAuthorizationsArgs, 'teamId'>>;
  clearNotificationCount?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  convertToUsageBilling?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeConvertToUsageBillingArgs, 'addons' | 'plan' | 'teamId'>>;
  createAlbum?: Resolver<ResolversTypes['Album'], ParentType, ContextType, RequireFields<RootMutationTypeCreateAlbumArgs, 'title'>>;
  createBranch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootMutationTypeCreateBranchArgs, 'name' | 'owner' | 'provider' | 'team'>>;
  createCodeComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeCreateCodeCommentArgs, 'anchorReference' | 'content' | 'sandboxId'>>;
  createCollection?: Resolver<ResolversTypes['Collection'], ParentType, ContextType, RequireFields<RootMutationTypeCreateCollectionArgs, 'path'>>;
  createComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeCreateCommentArgs, 'content' | 'sandboxId'>>;
  createContributionBranch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootMutationTypeCreateContributionBranchArgs, 'name' | 'owner' | 'provider'>>;
  createGithubPullRequestReview?: Resolver<ResolversTypes['PullRequestReview'], ParentType, ContextType, RequireFields<RootMutationTypeCreateGithubPullRequestReviewArgs, 'event' | 'name' | 'owner' | 'pullRequestNumber'>>;
  createOrUpdatePrivateNpmRegistry?: Resolver<ResolversTypes['PrivateRegistry'], ParentType, ContextType, RequireFields<RootMutationTypeCreateOrUpdatePrivateNpmRegistryArgs, 'enabledScopes' | 'limitToScopes' | 'proxyEnabled' | 'registryType' | 'teamId'>>;
  createPreviewComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeCreatePreviewCommentArgs, 'anchorReference' | 'content' | 'sandboxId'>>;
  createSandboxInvitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootMutationTypeCreateSandboxInvitationArgs, 'authorization' | 'email' | 'sandboxId'>>;
  createTeam?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeCreateTeamArgs, 'name'>>;
  deleteAlbum?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteAlbumArgs, 'id'>>;
  deleteBranch?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteBranchArgs, 'id'>>;
  deleteCollection?: Resolver<Array<ResolversTypes['Collection']>, ParentType, ContextType, RequireFields<RootMutationTypeDeleteCollectionArgs, 'path'>>;
  deleteComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteCommentArgs, 'commentId' | 'sandboxId'>>;
  deleteCurrentUser?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteCurrentUserArgs, 'confirm'>>;
  deleteGithubPullRequestReviewComment?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteGithubPullRequestReviewCommentArgs, 'commentId' | 'name' | 'owner'>>;
  deletePrivateNpmRegistry?: Resolver<Maybe<ResolversTypes['PrivateRegistry']>, ParentType, ContextType, RequireFields<RootMutationTypeDeletePrivateNpmRegistryArgs, 'teamId'>>;
  deleteProject?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteProjectArgs, 'name' | 'owner' | 'provider' | 'team'>>;
  deleteProjectById?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteProjectByIdArgs, 'id'>>;
  deleteSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypeDeleteSandboxesArgs, 'sandboxIds'>>;
  deleteWorkspace?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeDeleteWorkspaceArgs, 'teamId'>>;
  dismissGithubPullRequestReview?: Resolver<ResolversTypes['PullRequestReview'], ParentType, ContextType, RequireFields<RootMutationTypeDismissGithubPullRequestReviewArgs, 'message' | 'name' | 'owner' | 'pullRequestNumber' | 'pullRequestReviewId'>>;
  importBranch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootMutationTypeImportBranchArgs, 'branch' | 'name' | 'owner' | 'provider' | 'team'>>;
  importProject?: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<RootMutationTypeImportProjectArgs, 'name' | 'owner' | 'provider' | 'team'>>;
  importReadOnlyBranch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootMutationTypeImportReadOnlyBranchArgs, 'branch' | 'name' | 'owner' | 'provider'>>;
  importReadOnlyProject?: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<RootMutationTypeImportReadOnlyProjectArgs, 'name' | 'owner' | 'provider'>>;
  incrementSandboxVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeIncrementSandboxVersionArgs, 'sandboxId'>>;
  inviteToTeam?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeInviteToTeamArgs, 'teamId' | 'username'>>;
  inviteToTeamViaEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeInviteToTeamViaEmailArgs, 'email' | 'teamId'>>;
  joinEligibleWorkspace?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeJoinEligibleWorkspaceArgs, 'workspaceId'>>;
  joinLiveSession?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<RootMutationTypeJoinLiveSessionArgs, 'id'>>;
  joinUsageBillingBeta?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeJoinUsageBillingBetaArgs, 'teamId'>>;
  leaveTeam?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeLeaveTeamArgs, 'teamId'>>;
  makeSandboxesTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<RootMutationTypeMakeSandboxesTemplatesArgs, 'sandboxIds'>>;
  markAllNotificationsAsRead?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  markNotificationAsRead?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<RootMutationTypeMarkNotificationAsReadArgs, 'notificationId'>>;
  mergeGithubPullRequest?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeMergeGithubPullRequestArgs, 'mergeMethod' | 'name' | 'owner' | 'pullRequestNumber'>>;
  permanentlyDeleteSandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypePermanentlyDeleteSandboxesArgs, 'sandboxIds'>>;
  previewConvertToUsageBilling?: Resolver<ResolversTypes['InvoicePreview'], ParentType, ContextType, RequireFields<RootMutationTypePreviewConvertToUsageBillingArgs, 'addons' | 'plan' | 'teamId'>>;
  previewUpdateSubscriptionBillingInterval?: Resolver<ResolversTypes['BillingPreview'], ParentType, ContextType, RequireFields<RootMutationTypePreviewUpdateSubscriptionBillingIntervalArgs, 'billingInterval' | 'subscriptionId' | 'teamId'>>;
  previewUpdateUsageSubscriptionPlan?: Resolver<ResolversTypes['InvoicePreview'], ParentType, ContextType, RequireFields<RootMutationTypePreviewUpdateUsageSubscriptionPlanArgs, 'teamId'>>;
  reactivateSubscription?: Resolver<ResolversTypes['ProSubscription'], ParentType, ContextType, RequireFields<RootMutationTypeReactivateSubscriptionArgs, 'subscriptionId' | 'teamId'>>;
  redeemSandboxInvitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootMutationTypeRedeemSandboxInvitationArgs, 'invitationToken' | 'sandboxId'>>;
  redeemTeamInviteToken?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeRedeemTeamInviteTokenArgs, 'inviteToken'>>;
  rejectTeamInvitation?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeRejectTeamInvitationArgs, 'teamId'>>;
  removeCollaborator?: Resolver<ResolversTypes['Collaborator'], ParentType, ContextType, RequireFields<RootMutationTypeRemoveCollaboratorArgs, 'sandboxId' | 'username'>>;
  removeFromTeam?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeRemoveFromTeamArgs, 'teamId' | 'userId'>>;
  removeRequestedGithubPullRequestReviewers?: Resolver<Array<ResolversTypes['GithubRequestedReviewer']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveRequestedGithubPullRequestReviewersArgs, 'name' | 'owner' | 'pullRequestNumber' | 'reviewers'>>;
  removeSandboxesFromAlbum?: Resolver<Maybe<ResolversTypes['Album']>, ParentType, ContextType, RequireFields<RootMutationTypeRemoveSandboxesFromAlbumArgs, 'albumId' | 'sandboxIds'>>;
  renameCollection?: Resolver<Array<ResolversTypes['Collection']>, ParentType, ContextType, RequireFields<RootMutationTypeRenameCollectionArgs, 'newPath' | 'path'>>;
  renameSandbox?: Resolver<ResolversTypes['Sandbox'], ParentType, ContextType, RequireFields<RootMutationTypeRenameSandboxArgs, 'id' | 'title'>>;
  replyToGithubPullRequestReview?: Resolver<ResolversTypes['GitHubPullRequestReviewComment'], ParentType, ContextType, RequireFields<RootMutationTypeReplyToGithubPullRequestReviewArgs, 'body' | 'commentId' | 'name' | 'owner' | 'pullRequestNumber'>>;
  requestGithubPullRequestReviewers?: Resolver<Array<ResolversTypes['GithubRequestedReviewer']>, ParentType, ContextType, RequireFields<RootMutationTypeRequestGithubPullRequestReviewersArgs, 'name' | 'owner' | 'pullRequestNumber' | 'reviewers'>>;
  requestTeamInvitation?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeRequestTeamInvitationArgs, 'teamId'>>;
  resolveComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeResolveCommentArgs, 'commentId' | 'sandboxId'>>;
  revokeSandboxInvitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType, RequireFields<RootMutationTypeRevokeSandboxInvitationArgs, 'invitationId' | 'sandboxId'>>;
  revokeTeamInvitation?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeRevokeTeamInvitationArgs, 'teamId' | 'userId'>>;
  setBranchProtection?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootMutationTypeSetBranchProtectionArgs, 'branchId' | 'protected'>>;
  setDefaultTeamMemberAuthorization?: Resolver<ResolversTypes['WorkspaceSandboxSettings'], ParentType, ContextType, RequireFields<RootMutationTypeSetDefaultTeamMemberAuthorizationArgs, 'defaultAuthorization' | 'teamId'>>;
  setLiveSessionDefaultPermission?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<RootMutationTypeSetLiveSessionDefaultPermissionArgs, 'permission' | 'vmId'>>;
  setLiveSessionGuestPermission?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<RootMutationTypeSetLiveSessionGuestPermissionArgs, 'permission' | 'userId' | 'vmId'>>;
  setPreventSandboxesExport?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypeSetPreventSandboxesExportArgs, 'preventSandboxExport' | 'sandboxIds'>>;
  setPreventSandboxesLeavingWorkspace?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypeSetPreventSandboxesLeavingWorkspaceArgs, 'preventSandboxLeaving' | 'sandboxIds'>>;
  setPrimaryWorkspace?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeSetPrimaryWorkspaceArgs, 'primaryWorkspaceId'>>;
  setSandboxesFrozen?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypeSetSandboxesFrozenArgs, 'isFrozen' | 'sandboxIds'>>;
  setSandboxesPrivacy?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootMutationTypeSetSandboxesPrivacyArgs, 'sandboxIds'>>;
  setTeamAiConsent?: Resolver<ResolversTypes['TeamAiConsent'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamAiConsentArgs, 'privateRepositories' | 'privateSandboxes' | 'publicRepositories' | 'publicSandboxes' | 'teamId'>>;
  setTeamDescription?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamDescriptionArgs, 'description' | 'teamId'>>;
  setTeamLimits?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamLimitsArgs, 'teamId'>>;
  setTeamMetadata?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamMetadataArgs, 'metadata' | 'teamId'>>;
  setTeamMinimumPrivacy?: Resolver<ResolversTypes['WorkspaceSandboxSettings'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamMinimumPrivacyArgs, 'minimumPrivacy' | 'teamId' | 'updateDrafts'>>;
  setTeamName?: Resolver<ResolversTypes['Team'], ParentType, ContextType, RequireFields<RootMutationTypeSetTeamNameArgs, 'name' | 'teamId'>>;
  setWorkspaceSandboxSettings?: Resolver<ResolversTypes['WorkspaceSandboxSettings'], ParentType, ContextType, RequireFields<RootMutationTypeSetWorkspaceSandboxSettingsArgs, 'preventSandboxExport' | 'preventSandboxLeaving' | 'teamId'>>;
  softCancelSubscription?: Resolver<ResolversTypes['ProSubscription'], ParentType, ContextType, RequireFields<RootMutationTypeSoftCancelSubscriptionArgs, 'subscriptionId' | 'teamId'>>;
  startLiveSession?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<RootMutationTypeStartLiveSessionArgs, 'defaultPermission' | 'vmId'>>;
  stopLiveSession?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<RootMutationTypeStopLiveSessionArgs, 'vmId'>>;
  unbookmarkTemplate?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<RootMutationTypeUnbookmarkTemplateArgs, 'templateId'>>;
  unmakeSandboxesTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<RootMutationTypeUnmakeSandboxesTemplatesArgs, 'sandboxIds'>>;
  unresolveComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeUnresolveCommentArgs, 'commentId' | 'sandboxId'>>;
  updateAlbum?: Resolver<ResolversTypes['Album'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateAlbumArgs, 'id'>>;
  updateComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateCommentArgs, 'commentId' | 'sandboxId'>>;
  updateCurrentUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateCurrentUserArgs, 'username'>>;
  updateGithubPullRequestReview?: Resolver<ResolversTypes['PullRequestReview'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateGithubPullRequestReviewArgs, 'body' | 'name' | 'owner' | 'pullRequestNumber' | 'pullRequestReviewId'>>;
  updateGithubPullRequestReviewComment?: Resolver<ResolversTypes['GitHubPullRequestReviewComment'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateGithubPullRequestReviewCommentArgs, 'body' | 'commentId' | 'name' | 'owner'>>;
  updateNotificationPreferences?: Resolver<ResolversTypes['NotificationPreferences'], ParentType, ContextType, Partial<RootMutationTypeUpdateNotificationPreferencesArgs>>;
  updateNotificationReadStatus?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateNotificationReadStatusArgs, 'notificationId' | 'read'>>;
  updateProjectSettings?: Resolver<ResolversTypes['ProjectSettings'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateProjectSettingsArgs, 'projectId'>>;
  updateProjectVmTier?: Resolver<ResolversTypes['Resources'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateProjectVmTierArgs, 'projectId' | 'vmTier'>>;
  updateSandboxSettings?: Resolver<ResolversTypes['SandboxSettings'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateSandboxSettingsArgs, 'sandboxId'>>;
  updateSubscription?: Resolver<ResolversTypes['ProSubscription'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateSubscriptionArgs, 'subscriptionId' | 'teamId'>>;
  updateSubscriptionBillingInterval?: Resolver<ResolversTypes['ProSubscription'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateSubscriptionBillingIntervalArgs, 'billingInterval' | 'subscriptionId' | 'teamId'>>;
  updateUsageSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateUsageSubscriptionArgs, 'addons' | 'teamId'>>;
  updateUsageSubscriptionPlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateUsageSubscriptionPlanArgs, 'teamId'>>;
};

export type RootQueryTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootQueryType'] = ResolversParentTypes['RootQueryType']> = {
  album?: Resolver<Maybe<ResolversTypes['Album']>, ParentType, ContextType, RequireFields<RootQueryTypeAlbumArgs, 'albumId'>>;
  albums?: Resolver<Array<ResolversTypes['Album']>, ParentType, ContextType, RequireFields<RootQueryTypeAlbumsArgs, 'username'>>;
  branchById?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootQueryTypeBranchByIdArgs, 'id'>>;
  branchByName?: Resolver<ResolversTypes['Branch'], ParentType, ContextType, RequireFields<RootQueryTypeBranchByNameArgs, 'branch' | 'name' | 'owner' | 'provider'>>;
  curatedAlbums?: Resolver<Array<ResolversTypes['Album']>, ParentType, ContextType>;
  getLiveSession?: Resolver<Maybe<ResolversTypes['LiveSession']>, ParentType, ContextType, RequireFields<RootQueryTypeGetLiveSessionArgs, 'vmId'>>;
  git?: Resolver<Maybe<ResolversTypes['Git']>, ParentType, ContextType, RequireFields<RootQueryTypeGitArgs, 'branch' | 'path' | 'repo' | 'username'>>;
  githubOrganizationRepos?: Resolver<Maybe<Array<ResolversTypes['GithubRepo']>>, ParentType, ContextType, RequireFields<RootQueryTypeGithubOrganizationReposArgs, 'organization' | 'sort'>>;
  githubRepo?: Resolver<Maybe<ResolversTypes['GithubRepo']>, ParentType, ContextType, RequireFields<RootQueryTypeGithubRepoArgs, 'owner' | 'repo'>>;
  limits?: Resolver<ResolversTypes['Limits'], ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['CurrentUser']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<RootQueryTypeProjectArgs, 'gitProvider' | 'owner' | 'repo'>>;
  projects?: Resolver<Array<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<RootQueryTypeProjectsArgs, 'name' | 'owner' | 'provider'>>;
  recentTeamsByRepository?: Resolver<Array<ResolversTypes['TeamPreview']>, ParentType, ContextType, RequireFields<RootQueryTypeRecentTeamsByRepositoryArgs, 'name' | 'owner' | 'provider'>>;
  sandbox?: Resolver<Maybe<ResolversTypes['Sandbox']>, ParentType, ContextType, RequireFields<RootQueryTypeSandboxArgs, 'sandboxId'>>;
  sandboxEligibleWorkspace?: Resolver<Maybe<ResolversTypes['TeamPreview']>, ParentType, ContextType, RequireFields<RootQueryTypeSandboxEligibleWorkspaceArgs, 'sandboxId'>>;
  teamByToken?: Resolver<Maybe<ResolversTypes['TeamPreview']>, ParentType, ContextType, RequireFields<RootQueryTypeTeamByTokenArgs, 'inviteToken'>>;
};

export type RootSubscriptionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootSubscriptionType'] = ResolversParentTypes['RootSubscriptionType']> = {
  branchEvents?: SubscriptionResolver<ResolversTypes['BranchEvent'], "branchEvents", ParentType, ContextType, RequireFields<RootSubscriptionTypeBranchEventsArgs, 'branchName' | 'owner' | 'repo'>>;
  collaboratorAdded?: SubscriptionResolver<ResolversTypes['Collaborator'], "collaboratorAdded", ParentType, ContextType, RequireFields<RootSubscriptionTypeCollaboratorAddedArgs, 'sandboxId'>>;
  collaboratorChanged?: SubscriptionResolver<ResolversTypes['Collaborator'], "collaboratorChanged", ParentType, ContextType, RequireFields<RootSubscriptionTypeCollaboratorChangedArgs, 'sandboxId'>>;
  collaboratorRemoved?: SubscriptionResolver<ResolversTypes['Collaborator'], "collaboratorRemoved", ParentType, ContextType, RequireFields<RootSubscriptionTypeCollaboratorRemovedArgs, 'sandboxId'>>;
  commentAdded?: SubscriptionResolver<ResolversTypes['Comment'], "commentAdded", ParentType, ContextType, RequireFields<RootSubscriptionTypeCommentAddedArgs, 'sandboxId'>>;
  commentChanged?: SubscriptionResolver<ResolversTypes['Comment'], "commentChanged", ParentType, ContextType, RequireFields<RootSubscriptionTypeCommentChangedArgs, 'sandboxId'>>;
  commentRemoved?: SubscriptionResolver<ResolversTypes['Comment'], "commentRemoved", ParentType, ContextType, RequireFields<RootSubscriptionTypeCommentRemovedArgs, 'sandboxId'>>;
  githubEvents?: SubscriptionResolver<ResolversTypes['RepositoryEvent'], "githubEvents", ParentType, ContextType, RequireFields<RootSubscriptionTypeGithubEventsArgs, 'owner' | 'repo'>>;
  invitationChanged?: SubscriptionResolver<ResolversTypes['Invitation'], "invitationChanged", ParentType, ContextType, RequireFields<RootSubscriptionTypeInvitationChangedArgs, 'sandboxId'>>;
  invitationCreated?: SubscriptionResolver<ResolversTypes['Invitation'], "invitationCreated", ParentType, ContextType, RequireFields<RootSubscriptionTypeInvitationCreatedArgs, 'sandboxId'>>;
  invitationRemoved?: SubscriptionResolver<ResolversTypes['Invitation'], "invitationRemoved", ParentType, ContextType, RequireFields<RootSubscriptionTypeInvitationRemovedArgs, 'sandboxId'>>;
  liveSessionEvents?: SubscriptionResolver<ResolversTypes['LiveSessionEvent'], "liveSessionEvents", ParentType, ContextType, RequireFields<RootSubscriptionTypeLiveSessionEventsArgs, 'vmId'>>;
  projectCommits?: SubscriptionResolver<ResolversTypes['BranchLastCommit'], "projectCommits", ParentType, ContextType, RequireFields<RootSubscriptionTypeProjectCommitsArgs, 'owner' | 'repo'>>;
  projectConnections?: SubscriptionResolver<ResolversTypes['BranchConnections'], "projectConnections", ParentType, ContextType, RequireFields<RootSubscriptionTypeProjectConnectionsArgs, 'owner' | 'repo'>>;
  projectEvents?: SubscriptionResolver<ResolversTypes['ProjectEvent'], "projectEvents", ParentType, ContextType, RequireFields<RootSubscriptionTypeProjectEventsArgs, 'owner' | 'repo'>>;
  projectStatus?: SubscriptionResolver<ResolversTypes['BranchStatus'], "projectStatus", ParentType, ContextType, RequireFields<RootSubscriptionTypeProjectStatusArgs, 'owner' | 'repo'>>;
  sandboxChanged?: SubscriptionResolver<ResolversTypes['Sandbox'], "sandboxChanged", ParentType, ContextType, RequireFields<RootSubscriptionTypeSandboxChangedArgs, 'sandboxId'>>;
  teamEvents?: SubscriptionResolver<ResolversTypes['TeamEvent'], "teamEvents", ParentType, ContextType, Partial<RootSubscriptionTypeTeamEventsArgs>>;
};

export type SandboxResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sandbox'] = ResolversParentTypes['Sandbox']> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alwaysOn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  author?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  authorId?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  authorization?: Resolver<ResolversTypes['Authorization'], ParentType, ContextType>;
  baseGit?: Resolver<Maybe<ResolversTypes['Git']>, ParentType, ContextType>;
  collaborators?: Resolver<Array<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['Collection']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType, RequireFields<SandboxCommentArgs, 'commentId'>>;
  comments?: Resolver<Array<ResolversTypes['Comment']>, ParentType, ContextType>;
  customTemplate?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  draft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  forkCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  forkedTemplate?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType>;
  git?: Resolver<Maybe<ResolversTypes['Git']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invitations?: Resolver<Array<ResolversTypes['Invitation']>, ParentType, ContextType>;
  isFrozen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSse?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isV2?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastAccessedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  likeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  originalGit?: Resolver<Maybe<ResolversTypes['Git']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['SandboxProtectionSettings']>, ParentType, ContextType>;
  prNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  privacy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  removedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  screenshotOutdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  screenshotUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['SandboxSettings'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['Source'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['TeamPreview']>, ParentType, ContextType>;
  teamId?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SandboxProtectionSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SandboxProtectionSettings'] = ResolversParentTypes['SandboxProtectionSettings']> = {
  preventSandboxExport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  preventSandboxLeaving?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SandboxSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SandboxSettings'] = ResolversParentTypes['SandboxSettings']> = {
  aiConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Source'] = ResolversParentTypes['Source']> = {
  id?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['Status'] = ResolversParentTypes['Status']> = {
  hasChanges?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasConflicts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  remote?: Resolver<ResolversTypes['StatusCommitCounts'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['StatusCommitCounts'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusCommitCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusCommitCounts'] = ResolversParentTypes['StatusCommitCounts']> = {
  ahead?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  behind?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionItem'] = ResolversParentTypes['SubscriptionItem']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unitAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unitAmountDecimal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSchedule'] = ResolversParentTypes['SubscriptionSchedule']> = {
  billingInterval?: Resolver<Maybe<ResolversTypes['SubscriptionInterval']>, ParentType, ContextType>;
  current?: Resolver<Maybe<ResolversTypes['SubscriptionSchedulePhase']>, ParentType, ContextType>;
  upcoming?: Resolver<Maybe<ResolversTypes['SubscriptionSchedulePhase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionSchedulePhaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSchedulePhase'] = ResolversParentTypes['SubscriptionSchedulePhase']> = {
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SubscriptionItem']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['Team'] = ResolversParentTypes['Team']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookmarkedTemplates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType>;
  collections?: Resolver<Array<ResolversTypes['Collection']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drafts?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<TeamDraftsArgs>>;
  featureFlags?: Resolver<ResolversTypes['TeamFeatureFlags'], ParentType, ContextType>;
  frozen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  insertedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviteToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invitees?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  joinedPilotAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  legacy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limits?: Resolver<ResolversTypes['TeamLimits'], ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['TeamMember']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['TeamMetadata'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privateRegistry?: Resolver<Maybe<ResolversTypes['PrivateRegistry']>, ParentType, ContextType>;
  projects?: Resolver<Array<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<TeamProjectsArgs, 'syncData'>>;
  sandboxes?: Resolver<Array<ResolversTypes['Sandbox']>, ParentType, ContextType, Partial<TeamSandboxesArgs>>;
  settings?: Resolver<Maybe<ResolversTypes['WorkspaceSandboxSettings']>, ParentType, ContextType>;
  shortid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['ProSubscription']>, ParentType, ContextType, RequireFields<TeamSubscriptionArgs, 'includeCancelled'>>;
  subscriptionSchedule?: Resolver<Maybe<ResolversTypes['SubscriptionSchedule']>, ParentType, ContextType>;
  templates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TeamType'], ParentType, ContextType>;
  usage?: Resolver<ResolversTypes['TeamUsage'], ParentType, ContextType>;
  userAuthorizations?: Resolver<Array<ResolversTypes['UserAuthorization']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamAiConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamAiConsent'] = ResolversParentTypes['TeamAiConsent']> = {
  privateRepositories?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  privateSandboxes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicRepositories?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicSandboxes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamEvent'] = ResolversParentTypes['TeamEvent']> = {
  __resolveType: TypeResolveFn<'TeamSubscriptionEvent', ParentType, ContextType>;
};

export type TeamFeatureFlagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamFeatureFlags'] = ResolversParentTypes['TeamFeatureFlags']> = {
  friendOfCsb?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ubbBeta?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamLimits'] = ResolversParentTypes['TeamLimits']> = {
  includedCredits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedDrafts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedMembers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedPrivateSandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedPublicSandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedSandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedStorage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedVmTier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxEditors?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPrivateProjects?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPrivateSandboxes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPublicProjects?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPublicSandboxes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onDemandCreditLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onDemandSpendingLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamMember'] = ResolversParentTypes['TeamMember']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  githubUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamMetadata'] = ResolversParentTypes['TeamMetadata']> = {
  useCases?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamPreview'] = ResolversParentTypes['TeamPreview']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamSubscriptionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamSubscriptionEvent'] = ResolversParentTypes['TeamSubscriptionEvent']> = {
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscription?: Resolver<ResolversTypes['ProSubscription'], ParentType, ContextType>;
  teamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamUsage'] = ResolversParentTypes['TeamUsage']> = {
  credits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  editorsQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  privateProjectsQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  privateSandboxesQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publicProjectsQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publicSandboxesQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  restrictedSandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unrestrictedSandboxes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  bookmarked?: Resolver<Maybe<Array<Maybe<ResolversTypes['Bookmarked']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['UUID4']>, ParentType, ContextType>;
  insertedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  official?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sandbox?: Resolver<Maybe<ResolversTypes['Sandbox']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Uuid4ScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID4'], any> {
  name: 'UUID4';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalWorkspaceId?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  socialLinks?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAuthorizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAuthorization'] = ResolversParentTypes['UserAuthorization']> = {
  authorization?: Resolver<ResolversTypes['TeamMemberAuthorization'], ParentType, ContextType>;
  drafts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID4'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserFeatureFlagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserFeatureFlags'] = ResolversParentTypes['UserFeatureFlags']> = {
  ubbBeta?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserReferenceMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserReferenceMetadata'] = ResolversParentTypes['UserReferenceMetadata']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkspaceSandboxSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkspaceSandboxSettings'] = ResolversParentTypes['WorkspaceSandboxSettings']> = {
  aiConsent?: Resolver<ResolversTypes['TeamAiConsent'], ParentType, ContextType>;
  defaultAuthorization?: Resolver<ResolversTypes['TeamMemberAuthorization'], ParentType, ContextType>;
  minimumPrivacy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preventSandboxExport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  preventSandboxLeaving?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Album?: AlbumResolvers<ContextType>;
  Base64?: GraphQLScalarType;
  BillingDetails?: BillingDetailsResolvers<ContextType>;
  BillingPreview?: BillingPreviewResolvers<ContextType>;
  BookmarkEntity?: BookmarkEntityResolvers<ContextType>;
  Bookmarked?: BookmarkedResolvers<ContextType>;
  Branch?: BranchResolvers<ContextType>;
  BranchConnections?: BranchConnectionsResolvers<ContextType>;
  BranchEvent?: BranchEventResolvers<ContextType>;
  BranchLastCommit?: BranchLastCommitResolvers<ContextType>;
  BranchSettings?: BranchSettingsResolvers<ContextType>;
  BranchStatus?: BranchStatusResolvers<ContextType>;
  CodeReferenceMetadata?: CodeReferenceMetadataResolvers<ContextType>;
  Collaborator?: CollaboratorResolvers<ContextType>;
  Collection?: CollectionResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  CurrentUser?: CurrentUserResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Git?: GitResolvers<ContextType>;
  GitHubPullRequestComment?: GitHubPullRequestCommentResolvers<ContextType>;
  GitHubPullRequestReviewComment?: GitHubPullRequestReviewCommentResolvers<ContextType>;
  GitHubRepository?: GitHubRepositoryResolvers<ContextType>;
  GithubOrganization?: GithubOrganizationResolvers<ContextType>;
  GithubProfile?: GithubProfileResolvers<ContextType>;
  GithubRepo?: GithubRepoResolvers<ContextType>;
  GithubRequestedReviewer?: GithubRequestedReviewerResolvers<ContextType>;
  GithubRequestedTeam?: GithubRequestedTeamResolvers<ContextType>;
  ImageReferenceMetadata?: ImageReferenceMetadataResolvers<ContextType>;
  InstallationEvent?: InstallationEventResolvers<ContextType>;
  Invitation?: InvitationResolvers<ContextType>;
  InvoicePreview?: InvoicePreviewResolvers<ContextType>;
  LastCommit?: LastCommitResolvers<ContextType>;
  Limits?: LimitsResolvers<ContextType>;
  LiveSession?: LiveSessionResolvers<ContextType>;
  LiveSessionEvent?: LiveSessionEventResolvers<ContextType>;
  LiveSessionGuest?: LiveSessionGuestResolvers<ContextType>;
  LiveSessionHost?: LiveSessionHostResolvers<ContextType>;
  NaiveDateTime?: GraphQLScalarType;
  Notification?: NotificationResolvers<ContextType>;
  NotificationPreferences?: NotificationPreferencesResolvers<ContextType>;
  PreviewReferenceMetadata?: PreviewReferenceMetadataResolvers<ContextType>;
  PrivateRegistry?: PrivateRegistryResolvers<ContextType>;
  ProSubscription?: ProSubscriptionResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectEvent?: ProjectEventResolvers<ContextType>;
  ProjectSettings?: ProjectSettingsResolvers<ContextType>;
  PullRequest?: PullRequestResolvers<ContextType>;
  PullRequestCommentEvent?: PullRequestCommentEventResolvers<ContextType>;
  PullRequestEvent?: PullRequestEventResolvers<ContextType>;
  PullRequestReview?: PullRequestReviewResolvers<ContextType>;
  PullRequestReviewCommentEvent?: PullRequestReviewCommentEventResolvers<ContextType>;
  PullRequestReviewEvent?: PullRequestReviewEventResolvers<ContextType>;
  Reference?: ReferenceResolvers<ContextType>;
  ReferenceMetadata?: ReferenceMetadataResolvers<ContextType>;
  Repository?: RepositoryResolvers<ContextType>;
  RepositoryEvent?: RepositoryEventResolvers<ContextType>;
  Resources?: ResourcesResolvers<ContextType>;
  RootMutationType?: RootMutationTypeResolvers<ContextType>;
  RootQueryType?: RootQueryTypeResolvers<ContextType>;
  RootSubscriptionType?: RootSubscriptionTypeResolvers<ContextType>;
  Sandbox?: SandboxResolvers<ContextType>;
  SandboxProtectionSettings?: SandboxProtectionSettingsResolvers<ContextType>;
  SandboxSettings?: SandboxSettingsResolvers<ContextType>;
  Source?: SourceResolvers<ContextType>;
  Status?: StatusResolvers<ContextType>;
  StatusCommitCounts?: StatusCommitCountsResolvers<ContextType>;
  SubscriptionItem?: SubscriptionItemResolvers<ContextType>;
  SubscriptionSchedule?: SubscriptionScheduleResolvers<ContextType>;
  SubscriptionSchedulePhase?: SubscriptionSchedulePhaseResolvers<ContextType>;
  Team?: TeamResolvers<ContextType>;
  TeamAiConsent?: TeamAiConsentResolvers<ContextType>;
  TeamEvent?: TeamEventResolvers<ContextType>;
  TeamFeatureFlags?: TeamFeatureFlagsResolvers<ContextType>;
  TeamLimits?: TeamLimitsResolvers<ContextType>;
  TeamMember?: TeamMemberResolvers<ContextType>;
  TeamMetadata?: TeamMetadataResolvers<ContextType>;
  TeamPreview?: TeamPreviewResolvers<ContextType>;
  TeamSubscriptionEvent?: TeamSubscriptionEventResolvers<ContextType>;
  TeamUsage?: TeamUsageResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  UUID4?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserAuthorization?: UserAuthorizationResolvers<ContextType>;
  UserFeatureFlags?: UserFeatureFlagsResolvers<ContextType>;
  UserReferenceMetadata?: UserReferenceMetadataResolvers<ContextType>;
  WorkspaceSandboxSettings?: WorkspaceSandboxSettingsResolvers<ContextType>;
};

